var items = {
  "block.minecraft.acacia_button": "Dugme od bagrema",
  "block.minecraft.acacia_door": "Vrata od bagrema",
  "block.minecraft.acacia_fence": "Ograda od bagrema",
  "block.minecraft.acacia_fence_gate": "Vrata za ogradu od bagrema",
  "block.minecraft.acacia_hanging_sign": "Bagrem Viseći znak",
  "block.minecraft.acacia_leaves": "Lišće bagrema",
  "block.minecraft.acacia_log": "Bagremov panj",
  "block.minecraft.acacia_planks": "Daska od bagrema",
  "block.minecraft.acacia_pressure_plate": "Potisna ploča od bagrema",
  "block.minecraft.acacia_sapling": "Sadnica bagrema",
  "block.minecraft.acacia_shelf": "Polica od Akacije",
  "block.minecraft.acacia_sign": "Akacija Znak",
  "block.minecraft.acacia_slab": "Ploča od bagrema",
  "block.minecraft.acacia_stairs": "Stepenice od bagrema",
  "block.minecraft.acacia_trapdoor": "Poklopac od bagrema",
  "block.minecraft.acacia_wall_hanging_sign": "Viseći znak od bagrema",
  "block.minecraft.acacia_wall_sign": "Akacijin Zidni Znak",
  "block.minecraft.acacia_wood": "Drvo bagrema",
  "block.minecraft.activator_rail": "Pruga sa aktivatorom",
  "block.minecraft.air": "Vazduh",
  "block.minecraft.allium": "Ukrasni luk",
  "block.minecraft.amethyst_block": "Blok ametista",
  "block.minecraft.amethyst_cluster": "Nakupina ametista",
  "block.minecraft.ancient_debris": "Drevni ostaci",
  "block.minecraft.andesite": "Andezit",
  "block.minecraft.andesite_slab": "Ploča od Andezita",
  "block.minecraft.andesite_stairs": "Andezit Stepenice",
  "block.minecraft.andesite_wall": "Zid od Andezita",
  "block.minecraft.anvil": "Nakovanj",
  "block.minecraft.attached_melon_stem": "Privržena stabljika lubenice",
  "block.minecraft.attached_pumpkin_stem": "Privržena stabljika bundeve",
  "block.minecraft.azalea": "Azaleja",
  "block.minecraft.azalea_leaves": "Lišće azaleje",
  "block.minecraft.azure_bluet": "Plava maćuhica",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Blok bambusa",
  "block.minecraft.bamboo_button": "Bamboo Button",
  "block.minecraft.bamboo_door": "Bambus vrata",
  "block.minecraft.bamboo_fence": "Bamboo Fence",
  "block.minecraft.bamboo_fence_gate": "Bambusova ograda kapija",
  "block.minecraft.bamboo_hanging_sign": "Bambus Viseći Znak",
  "block.minecraft.bamboo_mosaic": "Bambus mozaik",
  "block.minecraft.bamboo_mosaic_slab": "Bambus mozaik ploča",
  "block.minecraft.bamboo_mosaic_stairs": "Bambus Mozaik Stepenice",
  "block.minecraft.bamboo_planks": "Bambusove daske",
  "block.minecraft.bamboo_pressure_plate": "Bambusova tlačna ploča",
  "block.minecraft.bamboo_sapling": "Mladi bambus",
  "block.minecraft.bamboo_shelf": "Polica od bambusa",
  "block.minecraft.bamboo_sign": "Bambusova tlačna ploča",
  "block.minecraft.bamboo_slab": "Bambus ploča",
  "block.minecraft.bamboo_stairs": "Bambusove stepenice",
  "block.minecraft.bamboo_trapdoor": "Bamboo Trapdoor",
  "block.minecraft.bamboo_wall_hanging_sign": "Viseći znak od bambusa",
  "block.minecraft.bamboo_wall_sign": "Viseći znak od bambusa",
  "block.minecraft.banner.base.black": "Potpuno crno polje",
  "block.minecraft.banner.base.blue": "Potpuno plavo polje",
  "block.minecraft.banner.base.brown": "Potpuno smeđe polje",
  "block.minecraft.banner.base.cyan": "Potpuno tirkizno polje",
  "block.minecraft.banner.base.gray": "Potpuno sivo polje",
  "block.minecraft.banner.base.green": "Potpuno zeleno polje",
  "block.minecraft.banner.base.light_blue": "Potpuno svjetloplavo polje",
  "block.minecraft.banner.base.light_gray": "Potpuno svjetlosivo polje",
  "block.minecraft.banner.base.lime": "Potpuno svjetlozeleno polje",
  "block.minecraft.banner.base.magenta": "Potpuno roza polje",
  "block.minecraft.banner.base.orange": "Potpuno narančasto polje",
  "block.minecraft.banner.base.pink": "Potpuno ružičasto polje",
  "block.minecraft.banner.base.purple": "Potpuno ljubičasto polje",
  "block.minecraft.banner.base.red": "Potpuno crveno polje",
  "block.minecraft.banner.base.white": "Potpuno bijelo polje",
  "block.minecraft.banner.base.yellow": "Potpuno žuto polje",
  "block.minecraft.banner.border.black": "Crni okvir",
  "block.minecraft.banner.border.blue": "Plavi okvir",
  "block.minecraft.banner.border.brown": "Braon okvir",
  "block.minecraft.banner.border.cyan": "Cijan okvir",
  "block.minecraft.banner.border.gray": "Sivi okvir",
  "block.minecraft.banner.border.green": "Zeleni okvir",
  "block.minecraft.banner.border.light_blue": "Svijetlo plavi okvir",
  "block.minecraft.banner.border.light_gray": "Svijetlo sivi okvir",
  "block.minecraft.banner.border.lime": "Svijetlo zeleni okvir",
  "block.minecraft.banner.border.magenta": "Rozi okvir",
  "block.minecraft.banner.border.orange": "Narandžasti okvir",
  "block.minecraft.banner.border.pink": "Rozi okvir",
  "block.minecraft.banner.border.purple": "Ljubičasti okvir",
  "block.minecraft.banner.border.red": "Crveni okvir",
  "block.minecraft.banner.border.white": "Bijeli okvir",
  "block.minecraft.banner.border.yellow": "Žuti okvir",
  "block.minecraft.banner.bricks.black": "Crna cigla",
  "block.minecraft.banner.bricks.blue": "Plava cigla",
  "block.minecraft.banner.bricks.brown": "Braon cigla",
  "block.minecraft.banner.bricks.cyan": "Cijan cigla",
  "block.minecraft.banner.bricks.gray": "Siva cigla",
  "block.minecraft.banner.bricks.green": "Zelena cigla",
  "block.minecraft.banner.bricks.light_blue": "Svijetlo plava cigla",
  "block.minecraft.banner.bricks.light_gray": "Svijetlo siva cigla",
  "block.minecraft.banner.bricks.lime": "Svijetlo zelena cigla",
  "block.minecraft.banner.bricks.magenta": "Purpurnocrvena cigla",
  "block.minecraft.banner.bricks.orange": "Narandžasta cigla",
  "block.minecraft.banner.bricks.pink": "Roza cigla",
  "block.minecraft.banner.bricks.purple": "Ljubičasta cigla",
  "block.minecraft.banner.bricks.red": "Crvena cigla",
  "block.minecraft.banner.bricks.white": "Bijela cigla",
  "block.minecraft.banner.bricks.yellow": "Žuta cigla",
  "block.minecraft.banner.circle.black": "Crni kružić",
  "block.minecraft.banner.circle.blue": "Plavi kružić",
  "block.minecraft.banner.circle.brown": "Braon kružić",
  "block.minecraft.banner.circle.cyan": "Cijan kružić",
  "block.minecraft.banner.circle.gray": "Sivi kružić",
  "block.minecraft.banner.circle.green": "Zeleni kružić",
  "block.minecraft.banner.circle.light_blue": "Svijetlo plavi kružić",
  "block.minecraft.banner.circle.light_gray": "Svijetlo sivi kružić",
  "block.minecraft.banner.circle.lime": "Svijetlo zeleni kružić",
  "block.minecraft.banner.circle.magenta": "Purpurnocrveni kružić",
  "block.minecraft.banner.circle.orange": "Narandžasti kružić",
  "block.minecraft.banner.circle.pink": "Rozi kružić",
  "block.minecraft.banner.circle.purple": "Ljubičasti kružić",
  "block.minecraft.banner.circle.red": "Crveni kružić",
  "block.minecraft.banner.circle.white": "Bijeli kružić",
  "block.minecraft.banner.circle.yellow": "Žuti kružić",
  "block.minecraft.banner.creeper.black": "Crni kriper",
  "block.minecraft.banner.creeper.blue": "Plavi kriper",
  "block.minecraft.banner.creeper.brown": "Braon kriper",
  "block.minecraft.banner.creeper.cyan": "Cijan kriper",
  "block.minecraft.banner.creeper.gray": "Sivi kriper",
  "block.minecraft.banner.creeper.green": "Zeleni kriper",
  "block.minecraft.banner.creeper.light_blue": "Svijetlo plavi kriper",
  "block.minecraft.banner.creeper.light_gray": "Svijetlo sivi kriper",
  "block.minecraft.banner.creeper.lime": "Svijetlo zeleni kriper",
  "block.minecraft.banner.creeper.magenta": "Purpurnocrveni kriper",
  "block.minecraft.banner.creeper.orange": "Narandžasti kriper",
  "block.minecraft.banner.creeper.pink": "Rozi kriper",
  "block.minecraft.banner.creeper.purple": "Ljubičasti kriper",
  "block.minecraft.banner.creeper.red": "Crveni kriper",
  "block.minecraft.banner.creeper.white": "Bijeli kriper",
  "block.minecraft.banner.creeper.yellow": "Žuti kriper",
  "block.minecraft.banner.cross.black": "Crna saltira",
  "block.minecraft.banner.cross.blue": "Plava saltira",
  "block.minecraft.banner.cross.brown": "Braon saltira",
  "block.minecraft.banner.cross.cyan": "Cijan saltira",
  "block.minecraft.banner.cross.gray": "Siva saltira",
  "block.minecraft.banner.cross.green": "Zelena saltira",
  "block.minecraft.banner.cross.light_blue": "Svijetlo plava saltira",
  "block.minecraft.banner.cross.light_gray": "Svijetlo siva saltira",
  "block.minecraft.banner.cross.lime": "Svijetlo zelena saltira",
  "block.minecraft.banner.cross.magenta": "Purpurnocrvena saltira",
  "block.minecraft.banner.cross.orange": "Narandžasta saltira",
  "block.minecraft.banner.cross.pink": "Roza saltira",
  "block.minecraft.banner.cross.purple": "Ljubičasta saltira",
  "block.minecraft.banner.cross.red": "Crvena saltira",
  "block.minecraft.banner.cross.white": "Bijela saltira",
  "block.minecraft.banner.cross.yellow": "Žuta saltira",
  "block.minecraft.banner.curly_border.black": "Crni uvučeni okvir",
  "block.minecraft.banner.curly_border.blue": "Plavi uvučeni okvir",
  "block.minecraft.banner.curly_border.brown": "Braon uvučeni okvir",
  "block.minecraft.banner.curly_border.cyan": "Cijan uvučeni okvir",
  "block.minecraft.banner.curly_border.gray": "Sivi uvučeni okvir",
  "block.minecraft.banner.curly_border.green": "Zeleni uvučeni okvir",
  "block.minecraft.banner.curly_border.light_blue": "Svijetlo plavi uvučeni okvir",
  "block.minecraft.banner.curly_border.light_gray": "Svijetlo sivi uvučeni okvir",
  "block.minecraft.banner.curly_border.lime": "Svijetlo zeleni uvučeni okvir",
  "block.minecraft.banner.curly_border.magenta": "Purpurnocrveni uvučeni okvir",
  "block.minecraft.banner.curly_border.orange": "Narandžasti uvučeni okvir",
  "block.minecraft.banner.curly_border.pink": "Rozi uvučeni okvir",
  "block.minecraft.banner.curly_border.purple": "Ljubičasti uvučeni okvir",
  "block.minecraft.banner.curly_border.red": "Crveni uvučeni okvir",
  "block.minecraft.banner.curly_border.white": "Bijeli uvučeni okvir",
  "block.minecraft.banner.curly_border.yellow": "Žuti uvučeni okvir",
  "block.minecraft.banner.diagonal_left.black": "Crna lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_left.blue": "Plava lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_left.brown": "Braon lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_left.cyan": "Cijan lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_left.gray": "Siva lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_left.green": "Zelena lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_left.light_blue": "Svijetlo plava lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_left.light_gray": "Svijetlo siva lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_left.lime": "Svijetlo zelena lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_left.magenta": "Purpurnocrvena lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_left.orange": "Narandžasta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_left.pink": "Roza lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_left.purple": "Ljubičasta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_left.red": "Crvena lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_left.white": "Bijela lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_left.yellow": "Žuta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_right.black": "Crna puna dijagonala",
  "block.minecraft.banner.diagonal_right.blue": "Plava puna dijagonala",
  "block.minecraft.banner.diagonal_right.brown": "Braon puna dijagonala",
  "block.minecraft.banner.diagonal_right.cyan": "Cijan puna dijagonala",
  "block.minecraft.banner.diagonal_right.gray": "Siva puna dijagonala",
  "block.minecraft.banner.diagonal_right.green": "Zelena puna dijagonala",
  "block.minecraft.banner.diagonal_right.light_blue": "Svijetlo plava puna dijagonala",
  "block.minecraft.banner.diagonal_right.light_gray": "Svijetlo siva puna dijagonala",
  "block.minecraft.banner.diagonal_right.lime": "Svijetlo zelena puna dijagonala",
  "block.minecraft.banner.diagonal_right.magenta": "Purpurnocrvena puna dijagonala",
  "block.minecraft.banner.diagonal_right.orange": "Narandžasta puna dijagonala",
  "block.minecraft.banner.diagonal_right.pink": "Roza puna dijagonala",
  "block.minecraft.banner.diagonal_right.purple": "Ljubičasta puna dijagonala",
  "block.minecraft.banner.diagonal_right.red": "Crvena puna dijagonala",
  "block.minecraft.banner.diagonal_right.white": "Bijela puna dijagonala",
  "block.minecraft.banner.diagonal_right.yellow": "Žuta puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.black": "Crna obrnuta puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.blue": "Plava obrnuta puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.brown": "Braon obrnuta puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.cyan": "Cijan obrnuta puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.gray": "Siva obrnuta puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.green": "Zelena obrnuta puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Svijetlo plava obrnuta puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Svijetlo siva obrnuta puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.lime": "Svijetlo zelena obrnuta puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.magenta": "Purpurnocrvena obrnuta puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.orange": "Narandžasta obrnuta puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.pink": "Roza obrnuta puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.purple": "Ljubičasta obrnuta puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.red": "Crvena obrnuta puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.white": "Bijela obrnuta puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.yellow": "Žuta obrnuta puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.black": "Crna obrnuta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.blue": "Plava obrnuta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.brown": "Braon obrnuta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.cyan": "Cijan obrnuta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.gray": "Siva obrnuta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.green": "Zelena obrnuta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Svijetlo plava obrnuta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Svijetlo siva obrnuta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.lime": "Svijetlo zelena obrnuta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.magenta": "Purpurnocrvena obrnuta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.orange": "Narandžasta obrnuta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.pink": "Roza obrnuta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.purple": "Ljubičasta obrnuta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.red": "Crvena obrnuta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.white": "Bijela obrnuta lijeva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.yellow": "Žuta obrnuta lijeva puna dijagonala",
  "block.minecraft.banner.flow.black": "Crna Spirala",
  "block.minecraft.banner.flow.blue": "Plava Spirala",
  "block.minecraft.banner.flow.brown": "Smeđa Spirala",
  "block.minecraft.banner.flow.cyan": "Cijan tok",
  "block.minecraft.banner.flow.gray": "Smeđa Spirala",
  "block.minecraft.banner.flow.green": "Zelena Spirala",
  "block.minecraft.banner.flow.light_blue": "Svijetllo Plava Spirala",
  "block.minecraft.banner.flow.light_gray": "Svijetlo Siva Spirala",
  "block.minecraft.banner.flow.lime": "Svjetlozelena Spirala",
  "block.minecraft.banner.flow.magenta": "Magenta Spirala",
  "block.minecraft.banner.flow.orange": "Narandžasta Spirala",
  "block.minecraft.banner.flow.pink": "Roza Spirala",
  "block.minecraft.banner.flow.purple": "Ljubičasta Spirala",
  "block.minecraft.banner.flow.red": "Crvena Spirala",
  "block.minecraft.banner.flow.white": "Bijela Spirala",
  "block.minecraft.banner.flow.yellow": "Žuta Spirala",
  "block.minecraft.banner.flower.black": "Crni cvijet",
  "block.minecraft.banner.flower.blue": "Plavi cvijet",
  "block.minecraft.banner.flower.brown": "Braon cvijet",
  "block.minecraft.banner.flower.cyan": "Cijan cvijet",
  "block.minecraft.banner.flower.gray": "Sivi cvijet",
  "block.minecraft.banner.flower.green": "Zeleni cvijet",
  "block.minecraft.banner.flower.light_blue": "Svijetlo plavi cvijet",
  "block.minecraft.banner.flower.light_gray": "Svijetlo sivi cvijet",
  "block.minecraft.banner.flower.lime": "Svijetlo zeleni cvijet",
  "block.minecraft.banner.flower.magenta": "Purpurnocrveni cvijet",
  "block.minecraft.banner.flower.orange": "Narandžasti cvijet",
  "block.minecraft.banner.flower.pink": "Rozi cvijet",
  "block.minecraft.banner.flower.purple": "Ljubičasti cvijet",
  "block.minecraft.banner.flower.red": "Crveni svijet",
  "block.minecraft.banner.flower.white": "Bijeli cvijet",
  "block.minecraft.banner.flower.yellow": "Žuti cvijet",
  "block.minecraft.banner.globe.black": "Crni globus",
  "block.minecraft.banner.globe.blue": "Plavi globus",
  "block.minecraft.banner.globe.brown": "Smeđi globus",
  "block.minecraft.banner.globe.cyan": "Tirkizni globus",
  "block.minecraft.banner.globe.gray": "Sivi globus",
  "block.minecraft.banner.globe.green": "Zeleni globus",
  "block.minecraft.banner.globe.light_blue": "Svjetloplavi globus",
  "block.minecraft.banner.globe.light_gray": "Svjetlosivi globus",
  "block.minecraft.banner.globe.lime": "Svjetlozeleni globus",
  "block.minecraft.banner.globe.magenta": "Roza globus",
  "block.minecraft.banner.globe.orange": "Narandžasti globus",
  "block.minecraft.banner.globe.pink": "Ružičasti globus",
  "block.minecraft.banner.globe.purple": "Ljubičasti globus",
  "block.minecraft.banner.globe.red": "Crveni globus",
  "block.minecraft.banner.globe.white": "Bijeli globus",
  "block.minecraft.banner.globe.yellow": "Žuti globus",
  "block.minecraft.banner.gradient.black": "Crni gradijent",
  "block.minecraft.banner.gradient.blue": "Plavi gradijent",
  "block.minecraft.banner.gradient.brown": "Braon gradijent",
  "block.minecraft.banner.gradient.cyan": "Cijan gradijent",
  "block.minecraft.banner.gradient.gray": "Sivi gradijent",
  "block.minecraft.banner.gradient.green": "Zeleni gradijent",
  "block.minecraft.banner.gradient.light_blue": "Svijetlo plavi gradijent",
  "block.minecraft.banner.gradient.light_gray": "Svijetlo sivi gradijent",
  "block.minecraft.banner.gradient.lime": "Svijetlo zeleni gradijent",
  "block.minecraft.banner.gradient.magenta": "Purpurnocrveni gradijent",
  "block.minecraft.banner.gradient.orange": "Narandžasti gradijent",
  "block.minecraft.banner.gradient.pink": "Rozi gradijent",
  "block.minecraft.banner.gradient.purple": "Ljubičasti gradijent",
  "block.minecraft.banner.gradient.red": "Crveni gradijent",
  "block.minecraft.banner.gradient.white": "Bijeli gradijent",
  "block.minecraft.banner.gradient.yellow": "Žuti gradijent",
  "block.minecraft.banner.gradient_up.black": "Crni donji gradijent",
  "block.minecraft.banner.gradient_up.blue": "Plavi donji gradijent",
  "block.minecraft.banner.gradient_up.brown": "Braon donji gradijent",
  "block.minecraft.banner.gradient_up.cyan": "Cijan donji gradijent",
  "block.minecraft.banner.gradient_up.gray": "Sivi donji gradijent",
  "block.minecraft.banner.gradient_up.green": "Zeleni donji gradijent",
  "block.minecraft.banner.gradient_up.light_blue": "Svijetlo plavi donji gradijent",
  "block.minecraft.banner.gradient_up.light_gray": "Svijetlo sivi donji gradijent",
  "block.minecraft.banner.gradient_up.lime": "Svijetlo zeleni donji gradijent",
  "block.minecraft.banner.gradient_up.magenta": "Purpurnocrveni donji gradijent",
  "block.minecraft.banner.gradient_up.orange": "Narandžasti donji gradijent",
  "block.minecraft.banner.gradient_up.pink": "Rozi donji gradijent",
  "block.minecraft.banner.gradient_up.purple": "Ljubičasti donji gradijent",
  "block.minecraft.banner.gradient_up.red": "Crveni donji gradijent",
  "block.minecraft.banner.gradient_up.white": "Bijeli donji gradijent",
  "block.minecraft.banner.gradient_up.yellow": "Žuti donji gradijent",
  "block.minecraft.banner.guster.black": "Crni Guster",
  "block.minecraft.banner.guster.blue": "Plavi Guster",
  "block.minecraft.banner.guster.brown": "Smeđi Guster",
  "block.minecraft.banner.guster.cyan": "cijan guster",
  "block.minecraft.banner.guster.gray": "Sivi Guster",
  "block.minecraft.banner.guster.green": "Zeleni Guster",
  "block.minecraft.banner.guster.light_blue": "Svijetlo Plavi Guster",
  "block.minecraft.banner.guster.light_gray": "Svijetlo Sivi Guster",
  "block.minecraft.banner.guster.lime": "Svijetlo Zeleni Guster",
  "block.minecraft.banner.guster.magenta": "Magenta Guster",
  "block.minecraft.banner.guster.orange": "Narandžasti Guster",
  "block.minecraft.banner.guster.pink": "Rozi Guster",
  "block.minecraft.banner.guster.purple": "Ljubičasti Guster",
  "block.minecraft.banner.guster.red": "Crveni Guster",
  "block.minecraft.banner.guster.white": "Bijeli Guster",
  "block.minecraft.banner.guster.yellow": "Žuti Guster",
  "block.minecraft.banner.half_horizontal.black": "Crna puna pruga",
  "block.minecraft.banner.half_horizontal.blue": "Plava puna pruga",
  "block.minecraft.banner.half_horizontal.brown": "Braon puna pruga",
  "block.minecraft.banner.half_horizontal.cyan": "Cijan puna pruga",
  "block.minecraft.banner.half_horizontal.gray": "Siva puna pruga",
  "block.minecraft.banner.half_horizontal.green": "Zelena puna pruga",
  "block.minecraft.banner.half_horizontal.light_blue": "Svijetlo plava puna pruga",
  "block.minecraft.banner.half_horizontal.light_gray": "Svijetlo siva puna pruga",
  "block.minecraft.banner.half_horizontal.lime": "Svijetlo zelena puna pruga",
  "block.minecraft.banner.half_horizontal.magenta": "Purpurnocrvena gornja polovina",
  "block.minecraft.banner.half_horizontal.orange": "Narandžasta puna pruga",
  "block.minecraft.banner.half_horizontal.pink": "Roza puna pruga",
  "block.minecraft.banner.half_horizontal.purple": "Ljubičasta puna pruga",
  "block.minecraft.banner.half_horizontal.red": "Crvena puna pruga",
  "block.minecraft.banner.half_horizontal.white": "Bijela puna pruga",
  "block.minecraft.banner.half_horizontal.yellow": "Žuta puna pruga",
  "block.minecraft.banner.half_horizontal_bottom.black": "Crna obrnuta puna pruga",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Plava obrnuta puna pruga",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Braon obrnuta puna pruga",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cijan obrnuta puna pruga",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Siva obrnuta puna pruga",
  "block.minecraft.banner.half_horizontal_bottom.green": "Zelena obrnuta puna pruga",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Svijetlo plava obrnuta puna pruga",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Svijetlo siva obrnuta puna pruga",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Svijetlo zelena obrnuta puna pruga",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Purpurnocrvena donja polovina",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Narandžasta obrnuta puna pruga",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Roza obrnuta puna pruga",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Ljubičasta obrnuta puna pruga",
  "block.minecraft.banner.half_horizontal_bottom.red": "Crvena obrnuta puna pruga",
  "block.minecraft.banner.half_horizontal_bottom.white": "Bijela obrnuta puna pruga",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Žuta obrnuta puna pruga",
  "block.minecraft.banner.half_vertical.black": "Crna puna traka",
  "block.minecraft.banner.half_vertical.blue": "Plava puna traka",
  "block.minecraft.banner.half_vertical.brown": "Braon puna traka",
  "block.minecraft.banner.half_vertical.cyan": "Cijan puna traka",
  "block.minecraft.banner.half_vertical.gray": "Siva puna traka",
  "block.minecraft.banner.half_vertical.green": "Zelena puna traka",
  "block.minecraft.banner.half_vertical.light_blue": "Svijetlo plava puna traka",
  "block.minecraft.banner.half_vertical.light_gray": "Svijetlo siva puna traka",
  "block.minecraft.banner.half_vertical.lime": "Svijetlo zelena puna traka",
  "block.minecraft.banner.half_vertical.magenta": "Purpurnocrvena lijeva polovina",
  "block.minecraft.banner.half_vertical.orange": "Narandžasta puna traka",
  "block.minecraft.banner.half_vertical.pink": "Roza puna traka",
  "block.minecraft.banner.half_vertical.purple": "Ljubičasta puna traka",
  "block.minecraft.banner.half_vertical.red": "Crvena puna traka",
  "block.minecraft.banner.half_vertical.white": "Bijela puna traka",
  "block.minecraft.banner.half_vertical.yellow": "Žuta puna traka",
  "block.minecraft.banner.half_vertical_right.black": "Crna obrnuta puna traka",
  "block.minecraft.banner.half_vertical_right.blue": "Plava obrnuta puna traka",
  "block.minecraft.banner.half_vertical_right.brown": "Braon obrnuta puna traka",
  "block.minecraft.banner.half_vertical_right.cyan": "Cijan obrnuta puna traka",
  "block.minecraft.banner.half_vertical_right.gray": "Siva obrnuta puna traka",
  "block.minecraft.banner.half_vertical_right.green": "Zelena obrnuta puna traka",
  "block.minecraft.banner.half_vertical_right.light_blue": "Svijetlo plava obrnuta puna traka",
  "block.minecraft.banner.half_vertical_right.light_gray": "Svijetlo siva obrnuta puna traka",
  "block.minecraft.banner.half_vertical_right.lime": "Svijetlo zelena obrnuta puna traka",
  "block.minecraft.banner.half_vertical_right.magenta": "Purpurnocrvena desna polovina",
  "block.minecraft.banner.half_vertical_right.orange": "Narandžasta obrnuta puna traka",
  "block.minecraft.banner.half_vertical_right.pink": "Roza obrnuta puna traka",
  "block.minecraft.banner.half_vertical_right.purple": "Ljubičasta obrnuta puna traka",
  "block.minecraft.banner.half_vertical_right.red": "Crvena obrnuta puna traka",
  "block.minecraft.banner.half_vertical_right.white": "Bijela obrnuta puna traka",
  "block.minecraft.banner.half_vertical_right.yellow": "Žuta obrnuta puna traka",
  "block.minecraft.banner.mojang.black": "Crna stvar",
  "block.minecraft.banner.mojang.blue": "Plava stvar",
  "block.minecraft.banner.mojang.brown": "Braon stvar",
  "block.minecraft.banner.mojang.cyan": "Cijan stvar",
  "block.minecraft.banner.mojang.gray": "Siva stvar",
  "block.minecraft.banner.mojang.green": "Zelena stvar",
  "block.minecraft.banner.mojang.light_blue": "Svijetlo plava stvar",
  "block.minecraft.banner.mojang.light_gray": "Svijetlo siva stvar",
  "block.minecraft.banner.mojang.lime": "Svijetlo zelena stvar",
  "block.minecraft.banner.mojang.magenta": "Purpurnocrvena stvar",
  "block.minecraft.banner.mojang.orange": "Narandžasta stvar",
  "block.minecraft.banner.mojang.pink": "Roza stvar",
  "block.minecraft.banner.mojang.purple": "Ljubičasta stvar",
  "block.minecraft.banner.mojang.red": "Crvena stvar",
  "block.minecraft.banner.mojang.white": "Bijela stvar",
  "block.minecraft.banner.mojang.yellow": "Žuta stvar",
  "block.minecraft.banner.piglin.black": "Crna njuška",
  "block.minecraft.banner.piglin.blue": "Plava njuška",
  "block.minecraft.banner.piglin.brown": "Smeđa njuška",
  "block.minecraft.banner.piglin.cyan": "Cijan njuška",
  "block.minecraft.banner.piglin.gray": "Siva njuška",
  "block.minecraft.banner.piglin.green": "Zelena njuška",
  "block.minecraft.banner.piglin.light_blue": "Svijetloplava njuška",
  "block.minecraft.banner.piglin.light_gray": "Svijetlosiva njuška",
  "block.minecraft.banner.piglin.lime": "Limeta njuška",
  "block.minecraft.banner.piglin.magenta": "Magenta njuška",
  "block.minecraft.banner.piglin.orange": "Narandžasta njuška",
  "block.minecraft.banner.piglin.pink": "Roze njuška",
  "block.minecraft.banner.piglin.purple": "Ljubičasta njuška",
  "block.minecraft.banner.piglin.red": "Crvena njuška",
  "block.minecraft.banner.piglin.white": "Bijela njuška",
  "block.minecraft.banner.piglin.yellow": "Žuta njuška",
  "block.minecraft.banner.rhombus.black": "Crni romb",
  "block.minecraft.banner.rhombus.blue": "Plavi romb",
  "block.minecraft.banner.rhombus.brown": "Braon romb",
  "block.minecraft.banner.rhombus.cyan": "Cijan romb",
  "block.minecraft.banner.rhombus.gray": "Sivi romb",
  "block.minecraft.banner.rhombus.green": "Zeleni romb",
  "block.minecraft.banner.rhombus.light_blue": "Svijetlo plavi romb",
  "block.minecraft.banner.rhombus.light_gray": "Svijetlo sivi romb",
  "block.minecraft.banner.rhombus.lime": "Svijetlo zeleni romb",
  "block.minecraft.banner.rhombus.magenta": "Purpurnocrveni romb",
  "block.minecraft.banner.rhombus.orange": "Narandžasti romb",
  "block.minecraft.banner.rhombus.pink": "Rozi romb",
  "block.minecraft.banner.rhombus.purple": "Ljubičasti romb",
  "block.minecraft.banner.rhombus.red": "Crveni romb",
  "block.minecraft.banner.rhombus.white": "Bijeli romb",
  "block.minecraft.banner.rhombus.yellow": "Žuti romb",
  "block.minecraft.banner.skull.black": "Crna lobanja",
  "block.minecraft.banner.skull.blue": "Plava lobanja",
  "block.minecraft.banner.skull.brown": "Braon lobanja",
  "block.minecraft.banner.skull.cyan": "Cijan lobanja",
  "block.minecraft.banner.skull.gray": "Siva lobanja",
  "block.minecraft.banner.skull.green": "Zelena lobanja",
  "block.minecraft.banner.skull.light_blue": "Svijetlo plava lobanja",
  "block.minecraft.banner.skull.light_gray": "Svijetlo siva lobanja",
  "block.minecraft.banner.skull.lime": "Svijetlo zelena lobanja",
  "block.minecraft.banner.skull.magenta": "Purpurnocrvena lobanja",
  "block.minecraft.banner.skull.orange": "Narandžasta lobanja",
  "block.minecraft.banner.skull.pink": "Roza lobanja",
  "block.minecraft.banner.skull.purple": "Ljubičasta lobanja",
  "block.minecraft.banner.skull.red": "Crvena lobanja",
  "block.minecraft.banner.skull.white": "Bijela lobanja",
  "block.minecraft.banner.skull.yellow": "Žuta lobanja",
  "block.minecraft.banner.small_stripes.black": "Crne pruge",
  "block.minecraft.banner.small_stripes.blue": "Plave pruge",
  "block.minecraft.banner.small_stripes.brown": "Braon pruge",
  "block.minecraft.banner.small_stripes.cyan": "Cijan pruge",
  "block.minecraft.banner.small_stripes.gray": "Sive pruge",
  "block.minecraft.banner.small_stripes.green": "Zelene pruge",
  "block.minecraft.banner.small_stripes.light_blue": "Svijetlo plave pruge",
  "block.minecraft.banner.small_stripes.light_gray": "Svijetlo sive pruge",
  "block.minecraft.banner.small_stripes.lime": "Svijetlo zelene pruge",
  "block.minecraft.banner.small_stripes.magenta": "Purpurnocrvene pruge",
  "block.minecraft.banner.small_stripes.orange": "Narandžaste pruge",
  "block.minecraft.banner.small_stripes.pink": "Roze pruge",
  "block.minecraft.banner.small_stripes.purple": "Ljubičaste pruge",
  "block.minecraft.banner.small_stripes.red": "Crvene pruge",
  "block.minecraft.banner.small_stripes.white": "Bijele pruge",
  "block.minecraft.banner.small_stripes.yellow": "Žute pruge",
  "block.minecraft.banner.square_bottom_left.black": "Crni donji desni kanton",
  "block.minecraft.banner.square_bottom_left.blue": "Plavi donji desni kanton",
  "block.minecraft.banner.square_bottom_left.brown": "Braon donji desni kanton",
  "block.minecraft.banner.square_bottom_left.cyan": "Cijan donji desni kanton",
  "block.minecraft.banner.square_bottom_left.gray": "Sivi donji desni kanton",
  "block.minecraft.banner.square_bottom_left.green": "Zeleni donji desni kanton",
  "block.minecraft.banner.square_bottom_left.light_blue": "Svijetlo plavi donji desni kanton",
  "block.minecraft.banner.square_bottom_left.light_gray": "Svijetlo sivi donji desni kanton",
  "block.minecraft.banner.square_bottom_left.lime": "Svijetlo zeleni donji desni kanton",
  "block.minecraft.banner.square_bottom_left.magenta": "Purpurnocrveni donji desni kanton",
  "block.minecraft.banner.square_bottom_left.orange": "Narandžasti donji desni kanton",
  "block.minecraft.banner.square_bottom_left.pink": "Rozi donji desni kanton",
  "block.minecraft.banner.square_bottom_left.purple": "Ljubičasti donji desni kanton",
  "block.minecraft.banner.square_bottom_left.red": "Crveni donji desni kanton",
  "block.minecraft.banner.square_bottom_left.white": "Bijeli donji desni kanton",
  "block.minecraft.banner.square_bottom_left.yellow": "Žuti donji desni kanton",
  "block.minecraft.banner.square_bottom_right.black": "Crni donji lijevi kanton",
  "block.minecraft.banner.square_bottom_right.blue": "Plavi donji lijevi kanton",
  "block.minecraft.banner.square_bottom_right.brown": "Braon donji lijevi kanton",
  "block.minecraft.banner.square_bottom_right.cyan": "Cijan donji lijevi kanton",
  "block.minecraft.banner.square_bottom_right.gray": "Sivi donji lijevi kanton",
  "block.minecraft.banner.square_bottom_right.green": "Zeleni donji lijevi kanton",
  "block.minecraft.banner.square_bottom_right.light_blue": "Svijetlo plavi donji lijevi kanton",
  "block.minecraft.banner.square_bottom_right.light_gray": "Svijetlo sivi donji lijevi kanton",
  "block.minecraft.banner.square_bottom_right.lime": "Svijetlo zeleni donji lijevi kanton",
  "block.minecraft.banner.square_bottom_right.magenta": "Purpurnocrveni donji lijevi kanton",
  "block.minecraft.banner.square_bottom_right.orange": "Narandžasti donji lijevi kanton",
  "block.minecraft.banner.square_bottom_right.pink": "Rozi donji lijevi kanton",
  "block.minecraft.banner.square_bottom_right.purple": "Ljubičasti donji lijevi kanton",
  "block.minecraft.banner.square_bottom_right.red": "Crveni donji lijevi kanton",
  "block.minecraft.banner.square_bottom_right.white": "Bijeli donji lijevi kanton",
  "block.minecraft.banner.square_bottom_right.yellow": "Žuti donji lijevi kanton",
  "block.minecraft.banner.square_top_left.black": "Crni gornji desni kanton",
  "block.minecraft.banner.square_top_left.blue": "Plavi gornji desni kanton",
  "block.minecraft.banner.square_top_left.brown": "Braon gornji desni kanton",
  "block.minecraft.banner.square_top_left.cyan": "Cijan gornji desni kanton",
  "block.minecraft.banner.square_top_left.gray": "Sivi gornji desni kanton",
  "block.minecraft.banner.square_top_left.green": "Zeleni gornji desni kanton",
  "block.minecraft.banner.square_top_left.light_blue": "Svijetlo plavi gornji desni kanton",
  "block.minecraft.banner.square_top_left.light_gray": "Svijetlo sivi gornji desni kanton",
  "block.minecraft.banner.square_top_left.lime": "Svijetlo zeleni gornji desni kanton",
  "block.minecraft.banner.square_top_left.magenta": "Purpurnocrveni gornji desni kanton",
  "block.minecraft.banner.square_top_left.orange": "Narandžasti gornji desni kanton",
  "block.minecraft.banner.square_top_left.pink": "Rozi gornji desni kanton",
  "block.minecraft.banner.square_top_left.purple": "Ljubičasti gornji desni kanton",
  "block.minecraft.banner.square_top_left.red": "Crveni gornji desni kanton",
  "block.minecraft.banner.square_top_left.white": "Bijeli gornji desni kanton",
  "block.minecraft.banner.square_top_left.yellow": "Žuti gornji desni kanton",
  "block.minecraft.banner.square_top_right.black": "Crni gornji lijevi kanton",
  "block.minecraft.banner.square_top_right.blue": "Plavi gornji lijevi kanton",
  "block.minecraft.banner.square_top_right.brown": "Braon gornji lijevi kanton",
  "block.minecraft.banner.square_top_right.cyan": "Cijan gornji lijevi kanton",
  "block.minecraft.banner.square_top_right.gray": "Sivi gornji lijevi kanton",
  "block.minecraft.banner.square_top_right.green": "Zeleni gornji lijevi kanton",
  "block.minecraft.banner.square_top_right.light_blue": "Svijetlo plavi gornji lijevi kanton",
  "block.minecraft.banner.square_top_right.light_gray": "Svijetlo sivi gornji lijevi kanton",
  "block.minecraft.banner.square_top_right.lime": "Svijetlo zeleni gornji lijevi kanton",
  "block.minecraft.banner.square_top_right.magenta": "Purpurnocrveni gornji lijevi kanton",
  "block.minecraft.banner.square_top_right.orange": "Narandžasti gornji lijevi kanton",
  "block.minecraft.banner.square_top_right.pink": "Rozi gornji lijevi kanton",
  "block.minecraft.banner.square_top_right.purple": "Ljubičasti gornji lijevi kanton",
  "block.minecraft.banner.square_top_right.red": "Crveni gornji lijevi kanton",
  "block.minecraft.banner.square_top_right.white": "Bijeli gornji lijevi kanton",
  "block.minecraft.banner.square_top_right.yellow": "Žuti gornji lijevi kanton",
  "block.minecraft.banner.straight_cross.black": "Crni krst",
  "block.minecraft.banner.straight_cross.blue": "Plavi krst",
  "block.minecraft.banner.straight_cross.brown": "Braon krst",
  "block.minecraft.banner.straight_cross.cyan": "Cijan krst",
  "block.minecraft.banner.straight_cross.gray": "Sivi krst",
  "block.minecraft.banner.straight_cross.green": "Zeleni krst",
  "block.minecraft.banner.straight_cross.light_blue": "Svijetlo plavi krst",
  "block.minecraft.banner.straight_cross.light_gray": "Svijetlo sivi krst",
  "block.minecraft.banner.straight_cross.lime": "Svijetlo zeleni krst",
  "block.minecraft.banner.straight_cross.magenta": "Purpurnocrveni krst",
  "block.minecraft.banner.straight_cross.orange": "Narandžasti krst",
  "block.minecraft.banner.straight_cross.pink": "Rozi krst",
  "block.minecraft.banner.straight_cross.purple": "Ljubičasti krst",
  "block.minecraft.banner.straight_cross.red": "Crveni krst",
  "block.minecraft.banner.straight_cross.white": "Bijeli krst",
  "block.minecraft.banner.straight_cross.yellow": "Žuti krst",
  "block.minecraft.banner.stripe_bottom.black": "Crni donji dio",
  "block.minecraft.banner.stripe_bottom.blue": "Plavi donji dio",
  "block.minecraft.banner.stripe_bottom.brown": "Braon donji dio",
  "block.minecraft.banner.stripe_bottom.cyan": "Cijan donji dio",
  "block.minecraft.banner.stripe_bottom.gray": "Sivi donji dio",
  "block.minecraft.banner.stripe_bottom.green": "Zeleni donji dio",
  "block.minecraft.banner.stripe_bottom.light_blue": "Svijetlo plavi donji dio",
  "block.minecraft.banner.stripe_bottom.light_gray": "Svijetlo sivi donji dio",
  "block.minecraft.banner.stripe_bottom.lime": "Svijetlo zeleni donji dio",
  "block.minecraft.banner.stripe_bottom.magenta": "Purpurnocrvena baza",
  "block.minecraft.banner.stripe_bottom.orange": "Narandžasti donji dio",
  "block.minecraft.banner.stripe_bottom.pink": "Rozi donji dio",
  "block.minecraft.banner.stripe_bottom.purple": "Ljubičasti donji dio",
  "block.minecraft.banner.stripe_bottom.red": "Crveni donji dio",
  "block.minecraft.banner.stripe_bottom.white": "Bijeli donji dio",
  "block.minecraft.banner.stripe_bottom.yellow": "Žuti donji dio",
  "block.minecraft.banner.stripe_center.black": "Crna traka",
  "block.minecraft.banner.stripe_center.blue": "Plava traka",
  "block.minecraft.banner.stripe_center.brown": "Braon traka",
  "block.minecraft.banner.stripe_center.cyan": "Cijan traka",
  "block.minecraft.banner.stripe_center.gray": "Siva traka",
  "block.minecraft.banner.stripe_center.green": "Zelena traka",
  "block.minecraft.banner.stripe_center.light_blue": "Svijetlo plava traka",
  "block.minecraft.banner.stripe_center.light_gray": "Svijetlo siva traka",
  "block.minecraft.banner.stripe_center.lime": "Svijetlo zelena traka",
  "block.minecraft.banner.stripe_center.magenta": "Purpurnocrvena traka",
  "block.minecraft.banner.stripe_center.orange": "Narandžasta traka",
  "block.minecraft.banner.stripe_center.pink": "Roza traka",
  "block.minecraft.banner.stripe_center.purple": "Ljubičasta traka",
  "block.minecraft.banner.stripe_center.red": "Crvena traka",
  "block.minecraft.banner.stripe_center.white": "Bijela traka",
  "block.minecraft.banner.stripe_center.yellow": "Žuta traka",
  "block.minecraft.banner.stripe_downleft.black": "Crna lijeva dijagonala",
  "block.minecraft.banner.stripe_downleft.blue": "Plava lijeva dijagonala",
  "block.minecraft.banner.stripe_downleft.brown": "Braon lijeva dijagonala",
  "block.minecraft.banner.stripe_downleft.cyan": "Cijan lijeva dijagonala",
  "block.minecraft.banner.stripe_downleft.gray": "Siva lijeva dijagonala",
  "block.minecraft.banner.stripe_downleft.green": "Zelena lijeva dijagonala",
  "block.minecraft.banner.stripe_downleft.light_blue": "Svijetlo plava lijeva dijagonala",
  "block.minecraft.banner.stripe_downleft.light_gray": "Svijetlo siva lijeva dijagonala",
  "block.minecraft.banner.stripe_downleft.lime": "Svijetlo zelena lijeva dijagonala",
  "block.minecraft.banner.stripe_downleft.magenta": "Purpurnocrvena lijeva dijagonala",
  "block.minecraft.banner.stripe_downleft.orange": "Narandžasta lijeva dijagonala",
  "block.minecraft.banner.stripe_downleft.pink": "Roza lijeva dijagonala",
  "block.minecraft.banner.stripe_downleft.purple": "Ljubičasta lijeva dijagonala",
  "block.minecraft.banner.stripe_downleft.red": "Crvena lijeva dijagonala",
  "block.minecraft.banner.stripe_downleft.white": "Bijela lijeva dijagonala",
  "block.minecraft.banner.stripe_downleft.yellow": "Žuta lijeva dijagonala",
  "block.minecraft.banner.stripe_downright.black": "Crna dijagonala",
  "block.minecraft.banner.stripe_downright.blue": "Plava dijagonala",
  "block.minecraft.banner.stripe_downright.brown": "Braon dijagonala",
  "block.minecraft.banner.stripe_downright.cyan": "Cijan dijagonala",
  "block.minecraft.banner.stripe_downright.gray": "Siva dijagonala",
  "block.minecraft.banner.stripe_downright.green": "Zelena dijagonala",
  "block.minecraft.banner.stripe_downright.light_blue": "Svijetlo plava dijagonala",
  "block.minecraft.banner.stripe_downright.light_gray": "Svijetlo siva dijagonala",
  "block.minecraft.banner.stripe_downright.lime": "Svijetlo zelena dijagonala",
  "block.minecraft.banner.stripe_downright.magenta": "Purpurnocrvena dijagonala",
  "block.minecraft.banner.stripe_downright.orange": "Narandžasta dijagonala",
  "block.minecraft.banner.stripe_downright.pink": "Roza dijagonala",
  "block.minecraft.banner.stripe_downright.purple": "Ljubičasta dijagonala",
  "block.minecraft.banner.stripe_downright.red": "Crvena dijagonala",
  "block.minecraft.banner.stripe_downright.white": "Bijela dijagonala",
  "block.minecraft.banner.stripe_downright.yellow": "Žuta dijagonala",
  "block.minecraft.banner.stripe_left.black": "Crna desna traka",
  "block.minecraft.banner.stripe_left.blue": "Plava desna traka",
  "block.minecraft.banner.stripe_left.brown": "Braon desna traka",
  "block.minecraft.banner.stripe_left.cyan": "Cijan desna traka",
  "block.minecraft.banner.stripe_left.gray": "Siva desna traka",
  "block.minecraft.banner.stripe_left.green": "Zelena desna traka",
  "block.minecraft.banner.stripe_left.light_blue": "Svijetlo plava desna traka",
  "block.minecraft.banner.stripe_left.light_gray": "Svijetlo siva desna traka",
  "block.minecraft.banner.stripe_left.lime": "Svijetlo zelena desna traka",
  "block.minecraft.banner.stripe_left.magenta": "Purpurnocrvena desna traka",
  "block.minecraft.banner.stripe_left.orange": "Narandžasta desna traka",
  "block.minecraft.banner.stripe_left.pink": "Roza desna traka",
  "block.minecraft.banner.stripe_left.purple": "Ljubičasta desna traka",
  "block.minecraft.banner.stripe_left.red": "Crvena desna traka",
  "block.minecraft.banner.stripe_left.white": "Bijela desna traka",
  "block.minecraft.banner.stripe_left.yellow": "Žuta desna traka",
  "block.minecraft.banner.stripe_middle.black": "Crna pruga",
  "block.minecraft.banner.stripe_middle.blue": "Plava pruga",
  "block.minecraft.banner.stripe_middle.brown": "Braon pruga",
  "block.minecraft.banner.stripe_middle.cyan": "Cijan pruga",
  "block.minecraft.banner.stripe_middle.gray": "Siva pruga",
  "block.minecraft.banner.stripe_middle.green": "Zelena pruga",
  "block.minecraft.banner.stripe_middle.light_blue": "Svijetlo plava pruga",
  "block.minecraft.banner.stripe_middle.light_gray": "Svijetlo siva pruga",
  "block.minecraft.banner.stripe_middle.lime": "Svijetlo zelena pruga",
  "block.minecraft.banner.stripe_middle.magenta": "Purpurnocrvena pruga",
  "block.minecraft.banner.stripe_middle.orange": "Narandžasta pruga",
  "block.minecraft.banner.stripe_middle.pink": "Roza pruga",
  "block.minecraft.banner.stripe_middle.purple": "Ljubičasta pruga",
  "block.minecraft.banner.stripe_middle.red": "Crvena pruga",
  "block.minecraft.banner.stripe_middle.white": "Bijela pruga",
  "block.minecraft.banner.stripe_middle.yellow": "Žuta pruga",
  "block.minecraft.banner.stripe_right.black": "Crna lijeva traka",
  "block.minecraft.banner.stripe_right.blue": "Plava lijeva traka",
  "block.minecraft.banner.stripe_right.brown": "Braon lijeva traka",
  "block.minecraft.banner.stripe_right.cyan": "Cijan lijeva traka",
  "block.minecraft.banner.stripe_right.gray": "Siva lijeva traka",
  "block.minecraft.banner.stripe_right.green": "Zelena lijeva traka",
  "block.minecraft.banner.stripe_right.light_blue": "Svijetlo plava lijeva traka",
  "block.minecraft.banner.stripe_right.light_gray": "Svijetlo siva lijeva traka",
  "block.minecraft.banner.stripe_right.lime": "Svijetlo zelena lijeva traka",
  "block.minecraft.banner.stripe_right.magenta": "Purpurnocrvena lijeva traka",
  "block.minecraft.banner.stripe_right.orange": "Narandžasta lijeva traka",
  "block.minecraft.banner.stripe_right.pink": "Roza lijeva traka",
  "block.minecraft.banner.stripe_right.purple": "Ljubičasta lijeva traka",
  "block.minecraft.banner.stripe_right.red": "Crvena lijeva traka",
  "block.minecraft.banner.stripe_right.white": "Bijela lijeva traka",
  "block.minecraft.banner.stripe_right.yellow": "Žuta lijeva traka",
  "block.minecraft.banner.stripe_top.black": "Crni gornji dio",
  "block.minecraft.banner.stripe_top.blue": "Plavi gornji dio",
  "block.minecraft.banner.stripe_top.brown": "Braon gornji dio",
  "block.minecraft.banner.stripe_top.cyan": "Cijan gornji dio",
  "block.minecraft.banner.stripe_top.gray": "Sivi gornji dio",
  "block.minecraft.banner.stripe_top.green": "Zeleni gornji dio",
  "block.minecraft.banner.stripe_top.light_blue": "Svijetlo plavi gornji dio",
  "block.minecraft.banner.stripe_top.light_gray": "Svijetlo sivi gornji dio",
  "block.minecraft.banner.stripe_top.lime": "Svijetlo zeleni gornji dio",
  "block.minecraft.banner.stripe_top.magenta": "Purpurnocrvena gornja pruga",
  "block.minecraft.banner.stripe_top.orange": "Narandžasti gornji dio",
  "block.minecraft.banner.stripe_top.pink": "Rozi gornji dio",
  "block.minecraft.banner.stripe_top.purple": "Ljubičasti gornji dio",
  "block.minecraft.banner.stripe_top.red": "Crveni gornji dio",
  "block.minecraft.banner.stripe_top.white": "Bijeli gornji dio",
  "block.minecraft.banner.stripe_top.yellow": "Žuti gornji dio",
  "block.minecraft.banner.triangle_bottom.black": "Crni trougao",
  "block.minecraft.banner.triangle_bottom.blue": "Plavi trougao",
  "block.minecraft.banner.triangle_bottom.brown": "Braon trougao",
  "block.minecraft.banner.triangle_bottom.cyan": "Cijan trougao",
  "block.minecraft.banner.triangle_bottom.gray": "Sivi trougao",
  "block.minecraft.banner.triangle_bottom.green": "Zeleni trougao",
  "block.minecraft.banner.triangle_bottom.light_blue": "Svijetlo plavi trougao",
  "block.minecraft.banner.triangle_bottom.light_gray": "Svijetlo sivi trougao",
  "block.minecraft.banner.triangle_bottom.lime": "Svijetlo zeleni trougao",
  "block.minecraft.banner.triangle_bottom.magenta": "Purpurnocrveni trougao",
  "block.minecraft.banner.triangle_bottom.orange": "Narandžasti trougao",
  "block.minecraft.banner.triangle_bottom.pink": "Rozi trougao",
  "block.minecraft.banner.triangle_bottom.purple": "Ljubičasti trougao",
  "block.minecraft.banner.triangle_bottom.red": "Crveni trougao",
  "block.minecraft.banner.triangle_bottom.white": "Bijeli trougao",
  "block.minecraft.banner.triangle_bottom.yellow": "Žuti trougao",
  "block.minecraft.banner.triangle_top.black": "Crni obrnuti trougao",
  "block.minecraft.banner.triangle_top.blue": "Plavi obrnuti trougao",
  "block.minecraft.banner.triangle_top.brown": "Braon obrnuti trougao",
  "block.minecraft.banner.triangle_top.cyan": "Cijan obrnuti trougao",
  "block.minecraft.banner.triangle_top.gray": "Sivi obrnuti trougao",
  "block.minecraft.banner.triangle_top.green": "Zeleni obrnuti trougao",
  "block.minecraft.banner.triangle_top.light_blue": "Svijetlo plavi obrnuti trougao",
  "block.minecraft.banner.triangle_top.light_gray": "Svijetlo sivi obrnuti trougao",
  "block.minecraft.banner.triangle_top.lime": "Svijetlo zeleni obrnuti trougao",
  "block.minecraft.banner.triangle_top.magenta": "Purpurnocrveni obrnuti trougao",
  "block.minecraft.banner.triangle_top.orange": "Narandžasti obrnuti trougao",
  "block.minecraft.banner.triangle_top.pink": "Rozi obrnuti trougao",
  "block.minecraft.banner.triangle_top.purple": "Ljubičasti obrnuti trougao",
  "block.minecraft.banner.triangle_top.red": "Crveni obrnuti trougao",
  "block.minecraft.banner.triangle_top.white": "Bijeli obrnuti trougao",
  "block.minecraft.banner.triangle_top.yellow": "Žuti obrnuti trougao",
  "block.minecraft.banner.triangles_bottom.black": "Crna uvučena osnova",
  "block.minecraft.banner.triangles_bottom.blue": "Plava uvučena osnova",
  "block.minecraft.banner.triangles_bottom.brown": "Braon uvučena osnova",
  "block.minecraft.banner.triangles_bottom.cyan": "Cijan uvučena osnova",
  "block.minecraft.banner.triangles_bottom.gray": "Siva uvučena osnova",
  "block.minecraft.banner.triangles_bottom.green": "Zelena uvučebna osnova",
  "block.minecraft.banner.triangles_bottom.light_blue": "Svijetlo plava uvučena osnova",
  "block.minecraft.banner.triangles_bottom.light_gray": "Svijetlo siva uvučena osnova",
  "block.minecraft.banner.triangles_bottom.lime": "Svijetlo zelena uvučena osnova",
  "block.minecraft.banner.triangles_bottom.magenta": "Purpurnocrvena uvučena osnova",
  "block.minecraft.banner.triangles_bottom.orange": "Narandžasta uvučena osnova",
  "block.minecraft.banner.triangles_bottom.pink": "Roza uvučena osnova",
  "block.minecraft.banner.triangles_bottom.purple": "Ljubičasta uvučena osnova",
  "block.minecraft.banner.triangles_bottom.red": "Crvena uvučena osnova",
  "block.minecraft.banner.triangles_bottom.white": "Bijela uvučena osnova",
  "block.minecraft.banner.triangles_bottom.yellow": "Žuta uvučena osnova",
  "block.minecraft.banner.triangles_top.black": "Crni uvučeni vrh",
  "block.minecraft.banner.triangles_top.blue": "Plavi uvučeni vrh",
  "block.minecraft.banner.triangles_top.brown": "Braon uvučeni vrh",
  "block.minecraft.banner.triangles_top.cyan": "Cijan uvučeni vrh",
  "block.minecraft.banner.triangles_top.gray": "Svijetlo sivi uvučeni vrh",
  "block.minecraft.banner.triangles_top.green": "Zeleni uvučeni vrh",
  "block.minecraft.banner.triangles_top.light_blue": "Svijetlo plavi uvučeni vrh",
  "block.minecraft.banner.triangles_top.light_gray": "Svijetlo sivi uvučeni vrh",
  "block.minecraft.banner.triangles_top.lime": "Svijetlo zeleni uvučeni vrh",
  "block.minecraft.banner.triangles_top.magenta": "Purpurnocrveni uvučeni vrh",
  "block.minecraft.banner.triangles_top.orange": "Narandžasti uvučeni vrh",
  "block.minecraft.banner.triangles_top.pink": "Rozi uvučeni vrh",
  "block.minecraft.banner.triangles_top.purple": "Ljubičasti uvučeni vrh",
  "block.minecraft.banner.triangles_top.red": "Crveni uvučeni vrh",
  "block.minecraft.banner.triangles_top.white": "Bijeli uvučeni vrh",
  "block.minecraft.banner.triangles_top.yellow": "Žuti uvučeni vrh",
  "block.minecraft.barrel": "Bure",
  "block.minecraft.barrier": "Barijera",
  "block.minecraft.basalt": "Bazalt",
  "block.minecraft.beacon": "Svjetionik",
  "block.minecraft.beacon.primary": "Primarna Moć",
  "block.minecraft.beacon.secondary": "Sekundarna Moć",
  "block.minecraft.bed.no_sleep": "Možete spavati samo tokom noći ili grmljavina",
  "block.minecraft.bed.not_safe": "Sada se ne možeš odmoriti; čudovišta su u blizini",
  "block.minecraft.bed.obstructed": "Ovaj krevet je prepriječen",
  "block.minecraft.bed.occupied": "Ovaj Krevet je zauzet",
  "block.minecraft.bed.too_far_away": "Sada se ne možeš odmoriti; krevet je predaleko",
  "block.minecraft.bedrock": "Temelj",
  "block.minecraft.bee_nest": "Gnijezdo pčela",
  "block.minecraft.beehive": "Košnica",
  "block.minecraft.beetroots": "Cvekla",
  "block.minecraft.bell": "Zvono",
  "block.minecraft.big_dripleaf": "Veliki kaplist",
  "block.minecraft.big_dripleaf_stem": "Stabljika velikog kaplista",
  "block.minecraft.birch_button": "Dugme od breze",
  "block.minecraft.birch_door": "Vrata od breze",
  "block.minecraft.birch_fence": "Brezina ograda",
  "block.minecraft.birch_fence_gate": "Brezina vrata za ogradu",
  "block.minecraft.birch_hanging_sign": "Breza Viseći znak",
  "block.minecraft.birch_leaves": "List breze",
  "block.minecraft.birch_log": "Brezin panj",
  "block.minecraft.birch_planks": "Daska od breze",
  "block.minecraft.birch_pressure_plate": "Potisna ploča od breze",
  "block.minecraft.birch_sapling": "Sadnica breze",
  "block.minecraft.birch_shelf": "Polica od breze",
  "block.minecraft.birch_sign": "Breza Znak",
  "block.minecraft.birch_slab": "Ploča od breze",
  "block.minecraft.birch_stairs": "Stepenice od breze",
  "block.minecraft.birch_trapdoor": "Poklopac od breze",
  "block.minecraft.birch_wall_hanging_sign": "Viseći znak od breze",
  "block.minecraft.birch_wall_sign": "Brezin Zidni Znak",
  "block.minecraft.birch_wood": "Drvo breze",
  "block.minecraft.black_banner": "Crna zastava",
  "block.minecraft.black_bed": "Crni krevet",
  "block.minecraft.black_candle": "Crna svijeća",
  "block.minecraft.black_candle_cake": "Torta s crnom svijećom",
  "block.minecraft.black_carpet": "Crni tepih",
  "block.minecraft.black_concrete": "Crni Beton",
  "block.minecraft.black_concrete_powder": "Crni Betonski Prah",
  "block.minecraft.black_glazed_terracotta": "Crna Glazirana Terakota",
  "block.minecraft.black_shulker_box": "Crna Kutija Shulkera",
  "block.minecraft.black_stained_glass": "Crno staklo",
  "block.minecraft.black_stained_glass_pane": "Crna staklena ploča",
  "block.minecraft.black_terracotta": "Crna Terakota",
  "block.minecraft.black_wool": "Crna Vuna",
  "block.minecraft.blackstone": "Crni kamen",
  "block.minecraft.blackstone_slab": "Ploča od crnog kamena",
  "block.minecraft.blackstone_stairs": "Stepenice od crnog kamena",
  "block.minecraft.blackstone_wall": "Zid od crnog kamena",
  "block.minecraft.blast_furnace": "Visoka peć",
  "block.minecraft.blue_banner": "Plava zastava",
  "block.minecraft.blue_bed": "Plavi krevet",
  "block.minecraft.blue_candle": "Plava svijeća",
  "block.minecraft.blue_candle_cake": "Torta s plavom svijećom",
  "block.minecraft.blue_carpet": "Plavi tepih",
  "block.minecraft.blue_concrete": "Plavi Beton",
  "block.minecraft.blue_concrete_powder": "Plavi Betonski Prah",
  "block.minecraft.blue_glazed_terracotta": "Plava Glazirana Terakota",
  "block.minecraft.blue_ice": "Plavi led",
  "block.minecraft.blue_orchid": "Plava orhideja",
  "block.minecraft.blue_shulker_box": "Plava Kutija Shulkera",
  "block.minecraft.blue_stained_glass": "Plavo staklo",
  "block.minecraft.blue_stained_glass_pane": "Plava staklena ploča",
  "block.minecraft.blue_terracotta": "Plava Terakota",
  "block.minecraft.blue_wool": "Plava Vuna",
  "block.minecraft.bone_block": "Koštani blok",
  "block.minecraft.bookshelf": "Polica za knjige",
  "block.minecraft.brain_coral": "Mozgasti koral",
  "block.minecraft.brain_coral_block": "Mozgasti koralni blok",
  "block.minecraft.brain_coral_fan": "Lepeza od mozgastog korala",
  "block.minecraft.brain_coral_wall_fan": "Zidna lepeza od mozgastog korala",
  "block.minecraft.brewing_stand": "Postolje za napitke",
  "block.minecraft.brick_slab": "Ploča od cigle",
  "block.minecraft.brick_stairs": "Kamene Stepenice",
  "block.minecraft.brick_wall": "Zid od cigla",
  "block.minecraft.bricks": "Cigle",
  "block.minecraft.brown_banner": "Braon zastava",
  "block.minecraft.brown_bed": "Braon krevet",
  "block.minecraft.brown_candle": "Smeđa svijeća",
  "block.minecraft.brown_candle_cake": "Torta sa smeđom svijećom",
  "block.minecraft.brown_carpet": "Braon tepih",
  "block.minecraft.brown_concrete": "Braon Beton",
  "block.minecraft.brown_concrete_powder": "Braon Betonski Prah",
  "block.minecraft.brown_glazed_terracotta": "Braon Glazirana Terakota",
  "block.minecraft.brown_mushroom": "Braon pečurka",
  "block.minecraft.brown_mushroom_block": "Braon blok pečurki",
  "block.minecraft.brown_shulker_box": "Braon Kutija Shulkera",
  "block.minecraft.brown_stained_glass": "Braon staklo",
  "block.minecraft.brown_stained_glass_pane": "Braon staklena ploča",
  "block.minecraft.brown_terracotta": "Braon Terakota",
  "block.minecraft.brown_wool": "Braon Vuna",
  "block.minecraft.bubble_column": "Kolona mjehura",
  "block.minecraft.bubble_coral": "Mjehurasti koral",
  "block.minecraft.bubble_coral_block": "Mjehurasti koralni blok",
  "block.minecraft.bubble_coral_fan": "Lepeza od mjehurastog korala",
  "block.minecraft.bubble_coral_wall_fan": "Zidna lepeza od mjehurastog korala",
  "block.minecraft.budding_amethyst": "Pupajući ametist",
  "block.minecraft.bush": "Žbun",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusov cvijet",
  "block.minecraft.cake": "Torta",
  "block.minecraft.calcite": "Kalcit",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrirani Sculk senzor",
  "block.minecraft.campfire": "Logorska vatra",
  "block.minecraft.candle": "Svijeća",
  "block.minecraft.candle_cake": "Torta sa svijećom",
  "block.minecraft.carrots": "Mrkve",
  "block.minecraft.cartography_table": "Kartografski sto",
  "block.minecraft.carved_pumpkin": "Izrezbarena bundeva",
  "block.minecraft.cauldron": "Kotao",
  "block.minecraft.cave_air": "Pećinski vazduh",
  "block.minecraft.cave_vines": "Špiljna loza",
  "block.minecraft.cave_vines_plant": "Biljka špiljne loze",
  "block.minecraft.chain": "Lanac",
  "block.minecraft.chain_command_block": "Lančani naredbeni blok",
  "block.minecraft.cherry_button": "Cherry Button",
  "block.minecraft.cherry_door": "Cherry Door",
  "block.minecraft.cherry_fence": "Trešnja Ograda",
  "block.minecraft.cherry_fence_gate": "Trešnja kapija ograde",
  "block.minecraft.cherry_hanging_sign": "Viseći znak trešnje",
  "block.minecraft.cherry_leaves": "trešnja listovi",
  "block.minecraft.cherry_log": "Trešnja log",
  "block.minecraft.cherry_planks": "Trešnja daske",
  "block.minecraft.cherry_pressure_plate": "Trešnja tlačna ploča",
  "block.minecraft.cherry_sapling": "Trešnja mladica",
  "block.minecraft.cherry_shelf": "Polica od trešnje",
  "block.minecraft.cherry_sign": "Trešnja sign",
  "block.minecraft.cherry_slab": "Cherry Slab",
  "block.minecraft.cherry_stairs": "Cherry Stairs",
  "block.minecraft.cherry_trapdoor": "Cherry Trapdoor",
  "block.minecraft.cherry_wall_hanging_sign": "Viseći znak na zidu trešnje",
  "block.minecraft.cherry_wall_sign": "Znak na zidu trešnje",
  "block.minecraft.cherry_wood": "Cherry Wood",
  "block.minecraft.chest": "Kovčeg",
  "block.minecraft.chipped_anvil": "Okrnjen nakovanj",
  "block.minecraft.chiseled_bookshelf": "Isklesana polica za knjige",
  "block.minecraft.chiseled_copper": "Isklesano Bakar",
  "block.minecraft.chiseled_deepslate": "Isklesani škriljevac",
  "block.minecraft.chiseled_nether_bricks": "Isklesane neder cigle",
  "block.minecraft.chiseled_polished_blackstone": "Isklesani polirani crni kamen",
  "block.minecraft.chiseled_quartz_block": "Isklesani blok kvarca",
  "block.minecraft.chiseled_red_sandstone": "Klesani Crveni Pješčani Kamen",
  "block.minecraft.chiseled_resin_bricks": "isklesane cigle od smole",
  "block.minecraft.chiseled_sandstone": "Klesani Pješčani Kamen",
  "block.minecraft.chiseled_stone_bricks": "Klesane Kamene Cigle",
  "block.minecraft.chiseled_tuff": "Isklesano Tuff",
  "block.minecraft.chiseled_tuff_bricks": "Isklesane cigle od tufa",
  "block.minecraft.chorus_flower": "Cvijet horusa",
  "block.minecraft.chorus_plant": "Horus",
  "block.minecraft.clay": "Glina",
  "block.minecraft.closed_eyeblossom": "Zatvoreni EyeBlossm",
  "block.minecraft.coal_block": "Blok Uglja",
  "block.minecraft.coal_ore": "Ruda Uglja",
  "block.minecraft.coarse_dirt": "Gruba zemlja",
  "block.minecraft.cobbled_deepslate": "Kameni škriljevac",
  "block.minecraft.cobbled_deepslate_slab": "Ploča od kamenog škriljevca",
  "block.minecraft.cobbled_deepslate_stairs": "Stepenice od kamenog škriljevca",
  "block.minecraft.cobbled_deepslate_wall": "Zid od kamenog škriljevca",
  "block.minecraft.cobblestone": "Blok kaldrme",
  "block.minecraft.cobblestone_slab": "Kamena ploča",
  "block.minecraft.cobblestone_stairs": "Kamene Stepenice",
  "block.minecraft.cobblestone_wall": "Kameni Zid",
  "block.minecraft.cobweb": "Mreža",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Naredbeni blok",
  "block.minecraft.comparator": "Redstone komparator",
  "block.minecraft.composter": "Kompost",
  "block.minecraft.conduit": "Konduktor",
  "block.minecraft.copper_bars": "Bakrene poluge",
  "block.minecraft.copper_block": "Blok bakra",
  "block.minecraft.copper_bulb": "Bakar Sijalica",
  "block.minecraft.copper_chain": "Bakreni lanac",
  "block.minecraft.copper_chest": "Bakrena kutija",
  "block.minecraft.copper_door": "Bakrena vrata",
  "block.minecraft.copper_golem_statue": "Statua Bakarnog Golema",
  "block.minecraft.copper_grate": "Bakarna rešetka",
  "block.minecraft.copper_lantern": "Bakrena lampa",
  "block.minecraft.copper_ore": "Bakrena ruda",
  "block.minecraft.copper_torch": "Bakrena baklja",
  "block.minecraft.copper_trapdoor": "Bakrena podna vrata",
  "block.minecraft.copper_wall_torch": "Zidna Bakrena Baklja",
  "block.minecraft.cornflower": "Različak",
  "block.minecraft.cracked_deepslate_bricks": "Napukle škriljave cigle",
  "block.minecraft.cracked_deepslate_tiles": "Napukle škriljave pločice",
  "block.minecraft.cracked_nether_bricks": "Napukle podzemske cigle",
  "block.minecraft.cracked_polished_blackstone_bricks": "Napukle cigle poliranog crnog kamena",
  "block.minecraft.cracked_stone_bricks": "Napukle Kamene Cigle",
  "block.minecraft.crafter": "Pravljač",
  "block.minecraft.crafting_table": "Radni sto",
  "block.minecraft.creaking_heart": "Srce koje škripi",
  "block.minecraft.creeper_head": "Kriperova glava",
  "block.minecraft.creeper_wall_head": "Zidna lobanja od kripera",
  "block.minecraft.crimson_button": "Grimizno dugme",
  "block.minecraft.crimson_door": "Grimizna vrata",
  "block.minecraft.crimson_fence": "Grimizna ograda",
  "block.minecraft.crimson_fence_gate": "Vrata za grimiznu ogradu",
  "block.minecraft.crimson_fungus": "Grimizna gljiva",
  "block.minecraft.crimson_hanging_sign": "Grimizni viseći znak",
  "block.minecraft.crimson_hyphae": "Grimizne hife",
  "block.minecraft.crimson_nylium": "Grimizni nilijum",
  "block.minecraft.crimson_planks": "Grimizne daske",
  "block.minecraft.crimson_pressure_plate": "Grimizna nagazna ploča",
  "block.minecraft.crimson_roots": "Grimizno korijenje",
  "block.minecraft.crimson_shelf": "Grimizna Polica",
  "block.minecraft.crimson_sign": "Grimizni znak",
  "block.minecraft.crimson_slab": "Grimizna ploča",
  "block.minecraft.crimson_stairs": "Grimizne stepenice",
  "block.minecraft.crimson_stem": "Grimizna stabljika",
  "block.minecraft.crimson_trapdoor": "Grimizna podna vrata",
  "block.minecraft.crimson_wall_hanging_sign": "Grimizni zidni viseći znak",
  "block.minecraft.crimson_wall_sign": "Grimizni zidni znak",
  "block.minecraft.crying_obsidian": "Plačući obsidijan",
  "block.minecraft.cut_copper": "Rezani bakar",
  "block.minecraft.cut_copper_slab": "Ploča od rezanog bakra",
  "block.minecraft.cut_copper_stairs": "Stepenice od rezanog bakra",
  "block.minecraft.cut_red_sandstone": "Izrezani crveni pješčani kamen",
  "block.minecraft.cut_red_sandstone_slab": "Ploča isječenog crvenog pješčanog kamena",
  "block.minecraft.cut_sandstone": "Izrezani pješčani kamen",
  "block.minecraft.cut_sandstone_slab": "Ploča isječenog pješčanog kamena",
  "block.minecraft.cyan_banner": "Cijan zastava",
  "block.minecraft.cyan_bed": "Cijan krevet",
  "block.minecraft.cyan_candle": "Tirkizna svijeća",
  "block.minecraft.cyan_candle_cake": "Torta s tirkiznom svijećom",
  "block.minecraft.cyan_carpet": "Cijan tepih",
  "block.minecraft.cyan_concrete": "Cijan Beton",
  "block.minecraft.cyan_concrete_powder": "Cijan Betonski Prah",
  "block.minecraft.cyan_glazed_terracotta": "Cijan Glazirana Terakota",
  "block.minecraft.cyan_shulker_box": "Cijan kutija shulkera",
  "block.minecraft.cyan_stained_glass": "Cijan staklo",
  "block.minecraft.cyan_stained_glass_pane": "Cijan staklena ploča",
  "block.minecraft.cyan_terracotta": "Cijan Terakota",
  "block.minecraft.cyan_wool": "Cijan Vuna",
  "block.minecraft.damaged_anvil": "Oštećeni nakovanj",
  "block.minecraft.dandelion": "Maslačak",
  "block.minecraft.dark_oak_button": "Dugme od tamnog hrasta",
  "block.minecraft.dark_oak_door": "Vrata od tamnog hrasta",
  "block.minecraft.dark_oak_fence": "Ograda od tamnog hrasta",
  "block.minecraft.dark_oak_fence_gate": "Vrata za ogradu od tamnog hrasta",
  "block.minecraft.dark_oak_hanging_sign": "Tamni Hrastov Viseći Znak",
  "block.minecraft.dark_oak_leaves": "List tamnog hrasta",
  "block.minecraft.dark_oak_log": "Tamni hrastov panj",
  "block.minecraft.dark_oak_planks": "Daska od tamnog hrasta",
  "block.minecraft.dark_oak_pressure_plate": "Potisna ploča od tamnog hrasta",
  "block.minecraft.dark_oak_sapling": "Sadnica od tamnog hrasta",
  "block.minecraft.dark_oak_shelf": "Polica od Tamnog Hrasta",
  "block.minecraft.dark_oak_sign": "Tamni hrast znak",
  "block.minecraft.dark_oak_slab": "Ploča od tamnog hrasta",
  "block.minecraft.dark_oak_stairs": "Stepenice od tamnog hrasta",
  "block.minecraft.dark_oak_trapdoor": "Poklopac od tamnog hrasta",
  "block.minecraft.dark_oak_wall_hanging_sign": "Viseći zidni znak od tamnog hrasta\n",
  "block.minecraft.dark_oak_wall_sign": "Tamni Hrastov Zidni Znak",
  "block.minecraft.dark_oak_wood": "Drvo tamnog hrasta",
  "block.minecraft.dark_prismarine": "Tamni prizmarin",
  "block.minecraft.dark_prismarine_slab": "Ploča od tamnog prizmarina",
  "block.minecraft.dark_prismarine_stairs": "Stepenice od tamnog prizmarina",
  "block.minecraft.daylight_detector": "Detektor dnevne svijetlosti",
  "block.minecraft.dead_brain_coral": "Mrtvi mozgasti koral",
  "block.minecraft.dead_brain_coral_block": "Mrtvi mozgasti koralni blok",
  "block.minecraft.dead_brain_coral_fan": "Lepeza od mrtvog mozgastog korala",
  "block.minecraft.dead_brain_coral_wall_fan": "Zidna lepeza od mrtvog mozgastog korala",
  "block.minecraft.dead_bubble_coral": "Mrtvi mjehurasti koral",
  "block.minecraft.dead_bubble_coral_block": "Mrtvi mjehurasti koralni blok",
  "block.minecraft.dead_bubble_coral_fan": "Lepeza od mrtvog mjehurastog korala",
  "block.minecraft.dead_bubble_coral_wall_fan": "Zidna lepeza od mrtvog mjehurastog korala",
  "block.minecraft.dead_bush": "Mrtvi grm",
  "block.minecraft.dead_fire_coral": "Mrtvi vatreni koral",
  "block.minecraft.dead_fire_coral_block": "Mrtvi vatreni koralni blok",
  "block.minecraft.dead_fire_coral_fan": "Lepeza od mrtvog vatrenog korala",
  "block.minecraft.dead_fire_coral_wall_fan": "Zidna lepeza od mrtvog vatrenog korala",
  "block.minecraft.dead_horn_coral": "Mrtvi rogasti koral",
  "block.minecraft.dead_horn_coral_block": "Mrtvi rogasti koralni blok",
  "block.minecraft.dead_horn_coral_fan": "Lepeza od mrtvog rogastog korala",
  "block.minecraft.dead_horn_coral_wall_fan": "Zidna lepeza od mrtvog rogastog korala",
  "block.minecraft.dead_tube_coral": "Mrtvi cijevasti koral",
  "block.minecraft.dead_tube_coral_block": "Mrtvi cijevasti koralni blok",
  "block.minecraft.dead_tube_coral_fan": "Lepeza od mrtvog cijevastog korala",
  "block.minecraft.dead_tube_coral_wall_fan": "Zidna lepeza od mrtvog cijevastog korala",
  "block.minecraft.decorated_pot": "Dekorisana vaza",
  "block.minecraft.deepslate": "Škriljevac",
  "block.minecraft.deepslate_brick_slab": "Ploča od škriljavih cigli",
  "block.minecraft.deepslate_brick_stairs": "Stepenice od škriljavih cigli",
  "block.minecraft.deepslate_brick_wall": "Zid od škriljavih cigli",
  "block.minecraft.deepslate_bricks": "Škriljave cigle",
  "block.minecraft.deepslate_coal_ore": "Škriljava ugljena ruda",
  "block.minecraft.deepslate_copper_ore": "Škriljava bakrena ruda",
  "block.minecraft.deepslate_diamond_ore": "Škriljava dijamantna ruda",
  "block.minecraft.deepslate_emerald_ore": "Škriljava smaragdna ruda",
  "block.minecraft.deepslate_gold_ore": "Škriljava zlatna ruda",
  "block.minecraft.deepslate_iron_ore": "Škriljava željezna ruda",
  "block.minecraft.deepslate_lapis_ore": "Škriljava lazulitna ruda",
  "block.minecraft.deepslate_redstone_ore": "Škriljava redstone ruda",
  "block.minecraft.deepslate_tile_slab": "Ploča od škriljavih pločica",
  "block.minecraft.deepslate_tile_stairs": "Stepenice od škriljavih pločica",
  "block.minecraft.deepslate_tile_wall": "Zid od škriljavih pločica",
  "block.minecraft.deepslate_tiles": "Škriljave pločice",
  "block.minecraft.detector_rail": "Pruga s detektorom",
  "block.minecraft.diamond_block": "Blok Dijamanta",
  "block.minecraft.diamond_ore": "Ruda Dijamanta",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Ploča od Diorita",
  "block.minecraft.diorite_stairs": "Diorit Stepenice",
  "block.minecraft.diorite_wall": "Zid od Diorita",
  "block.minecraft.dirt": "Zemlja",
  "block.minecraft.dirt_path": "Zemljani put",
  "block.minecraft.dispenser": "Automat",
  "block.minecraft.dragon_egg": "Zmajevo Jaje",
  "block.minecraft.dragon_head": "Zmajeva glava",
  "block.minecraft.dragon_wall_head": "Zidna lobanja od zmaja",
  "block.minecraft.dried_ghast": "Osušeni ghast",
  "block.minecraft.dried_kelp_block": "Osušen blok morske alge",
  "block.minecraft.dripstone_block": "Blok speleotema",
  "block.minecraft.dropper": "Izbacivač",
  "block.minecraft.emerald_block": "Blok smaragda",
  "block.minecraft.emerald_ore": "Ruda Smaragda",
  "block.minecraft.enchanting_table": "Magični sto",
  "block.minecraft.end_gateway": "End prolaz",
  "block.minecraft.end_portal": "End Portal",
  "block.minecraft.end_portal_frame": "End Protal ram",
  "block.minecraft.end_rod": "End štap",
  "block.minecraft.end_stone": "Enderski Kamen",
  "block.minecraft.end_stone_brick_slab": "Ploča od kamenih end cigala",
  "block.minecraft.end_stone_brick_stairs": "Stepenice od kamenih cigla iz enda",
  "block.minecraft.end_stone_brick_wall": "Zid od kamene end cigle",
  "block.minecraft.end_stone_bricks": "End kamene cigle",
  "block.minecraft.ender_chest": "Ender kovčeg",
  "block.minecraft.exposed_chiseled_copper": "Otkriveni klesani bakar",
  "block.minecraft.exposed_copper": "Izloženi bakar",
  "block.minecraft.exposed_copper_bars": "Otkrivene Bakarne Šipke",
  "block.minecraft.exposed_copper_bulb": "Otkrivena bakarna lampa",
  "block.minecraft.exposed_copper_chain": "Otkriveni Bakarni Lanac",
  "block.minecraft.exposed_copper_chest": "Otkriveni Bakarni Kovčeg",
  "block.minecraft.exposed_copper_door": "Otkrivena bakarna vrata",
  "block.minecraft.exposed_copper_golem_statue": "Otkrivena Statua Bakarnog Golema",
  "block.minecraft.exposed_copper_grate": "Otkrivena bakarna rešetka",
  "block.minecraft.exposed_copper_lantern": "Otkrivena Bakarna Lampa",
  "block.minecraft.exposed_copper_trapdoor": "Otkriveni bakarni kapak",
  "block.minecraft.exposed_cut_copper": "Izloženi rezani bakar",
  "block.minecraft.exposed_cut_copper_slab": "Ploča od izloženog rezanog bakra",
  "block.minecraft.exposed_cut_copper_stairs": "Stube od izloženog rezanog bakra",
  "block.minecraft.exposed_lightning_rod": "Otkriveni Gromobran",
  "block.minecraft.farmland": "Polje",
  "block.minecraft.fern": "Paprat",
  "block.minecraft.fire": "Vatra",
  "block.minecraft.fire_coral": "Vatreni koral",
  "block.minecraft.fire_coral_block": "Vatreni koralni blok",
  "block.minecraft.fire_coral_fan": "Lepeza od vatrenog korala",
  "block.minecraft.fire_coral_wall_fan": "Zidna lepeza od vatrenog korala",
  "block.minecraft.firefly_bush": "Grm Krijesnica",
  "block.minecraft.fletching_table": "Streljaški sto",
  "block.minecraft.flower_pot": "Saksija",
  "block.minecraft.flowering_azalea": "Cvatuća azaleja",
  "block.minecraft.flowering_azalea_leaves": "Cvatući azaleja listovi",
  "block.minecraft.frogspawn": "Stvaranje Žabe",
  "block.minecraft.frosted_ice": "Smrznuti led",
  "block.minecraft.furnace": "Peć",
  "block.minecraft.gilded_blackstone": "Pozlaćeni crni kamen",
  "block.minecraft.glass": "Staklo",
  "block.minecraft.glass_pane": "Staklena ploča",
  "block.minecraft.glow_lichen": "Svjetleći lišaj",
  "block.minecraft.glowstone": "Svijetleći kamen",
  "block.minecraft.gold_block": "Blok zlata",
  "block.minecraft.gold_ore": "Ruda Zlata",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Ploča od Granita",
  "block.minecraft.granite_stairs": "Granitne Stepenice",
  "block.minecraft.granite_wall": "Zid od Granita",
  "block.minecraft.grass": "Trava",
  "block.minecraft.grass_block": "Blok trave",
  "block.minecraft.gravel": "Šljunak",
  "block.minecraft.gray_banner": "Siva zastava",
  "block.minecraft.gray_bed": "Sivi krevet",
  "block.minecraft.gray_candle": "Siva svijeća",
  "block.minecraft.gray_candle_cake": "Torta sa sivom svijećom",
  "block.minecraft.gray_carpet": "Sivi Tepih",
  "block.minecraft.gray_concrete": "Sivi Beton",
  "block.minecraft.gray_concrete_powder": "Sivi Betonski Prah",
  "block.minecraft.gray_glazed_terracotta": "Siva Glazirana Terakota",
  "block.minecraft.gray_shulker_box": "Siva kutija shulkera",
  "block.minecraft.gray_stained_glass": "Sivo staklo",
  "block.minecraft.gray_stained_glass_pane": "Siva staklena ploča",
  "block.minecraft.gray_terracotta": "Siva Terakota",
  "block.minecraft.gray_wool": "Siva Vuna",
  "block.minecraft.green_banner": "Zelena zastava",
  "block.minecraft.green_bed": "Zeleni krevet",
  "block.minecraft.green_candle": "Zelena svijeća",
  "block.minecraft.green_candle_cake": "Torta sa zelenom svijećom",
  "block.minecraft.green_carpet": "Zeleni tepih",
  "block.minecraft.green_concrete": "Zeleni Beton",
  "block.minecraft.green_concrete_powder": "Zeleni Betonski Prah",
  "block.minecraft.green_glazed_terracotta": "Zelena Glazirana Terakota",
  "block.minecraft.green_shulker_box": "Zelena Kutija Shulkera",
  "block.minecraft.green_stained_glass": "Zeleno staklo",
  "block.minecraft.green_stained_glass_pane": "Zelena staklena ploča",
  "block.minecraft.green_terracotta": "Zelena Terakota",
  "block.minecraft.green_wool": "Zelena Vuna",
  "block.minecraft.grindstone": "Mlinski kamen",
  "block.minecraft.hanging_roots": "Viseće korjenje",
  "block.minecraft.hay_block": "Bala Sijena",
  "block.minecraft.heavy_core": "Teška jezgra",
  "block.minecraft.heavy_weighted_pressure_plate": "Teška Otežana Ploča",
  "block.minecraft.honey_block": "Blok meda",
  "block.minecraft.honeycomb_block": "Blok saća",
  "block.minecraft.hopper": "Lijevak",
  "block.minecraft.horn_coral": "Rogasti koral",
  "block.minecraft.horn_coral_block": "Rogasti koralni blok",
  "block.minecraft.horn_coral_fan": "Lepeza od rogastog korala",
  "block.minecraft.horn_coral_wall_fan": "Zidna lepeza od rogastog korala",
  "block.minecraft.ice": "Led",
  "block.minecraft.infested_chiseled_stone_bricks": "Opustošena izdubljena kamena cigla",
  "block.minecraft.infested_cobblestone": "Opustošen kaldrmasti kamen",
  "block.minecraft.infested_cracked_stone_bricks": "Opustošena napukla kamena cigla",
  "block.minecraft.infested_deepslate": "Opustošeni škriljevac",
  "block.minecraft.infested_mossy_stone_bricks": "Opustošena mahovita kamena cigla",
  "block.minecraft.infested_stone": "Opustošen kamen",
  "block.minecraft.infested_stone_bricks": "Opustošena kamena cigla",
  "block.minecraft.iron_bars": "Gvozdene Šipke",
  "block.minecraft.iron_block": "Blok gvožđa",
  "block.minecraft.iron_chain": "Gvozdeni lanac",
  "block.minecraft.iron_door": "Gvozdena vrata",
  "block.minecraft.iron_ore": "Ruda gvožđa",
  "block.minecraft.iron_trapdoor": "Gvozdeni Poklopac",
  "block.minecraft.jack_o_lantern": "Svijetleća bundeva",
  "block.minecraft.jigsaw": "Blok slagalica",
  "block.minecraft.jukebox": "Džuboks",
  "block.minecraft.jungle_button": "Dugme od džungle",
  "block.minecraft.jungle_door": "Vrata od džungle",
  "block.minecraft.jungle_fence": "Džunglina Ograda",
  "block.minecraft.jungle_fence_gate": "Džunglina vrata za ogradu",
  "block.minecraft.jungle_hanging_sign": "Džungla Viseći znak",
  "block.minecraft.jungle_leaves": "List džungle",
  "block.minecraft.jungle_log": "Džunglin panj",
  "block.minecraft.jungle_planks": "Daska od džungle",
  "block.minecraft.jungle_pressure_plate": "Potisna ploča od džungle",
  "block.minecraft.jungle_sapling": "Sadnica džungle",
  "block.minecraft.jungle_shelf": "Polica Džungle",
  "block.minecraft.jungle_sign": "Džungla Znak",
  "block.minecraft.jungle_slab": "Ploča od džungle",
  "block.minecraft.jungle_stairs": "Stepenice od džungle",
  "block.minecraft.jungle_trapdoor": "Poklopac od džungle",
  "block.minecraft.jungle_wall_hanging_sign": "Viseći znak drveta džungle",
  "block.minecraft.jungle_wall_sign": "Džunglin Zidni Znak",
  "block.minecraft.jungle_wood": "Drvo Džungle",
  "block.minecraft.kelp": "Alga",
  "block.minecraft.kelp_plant": "Biljka morske alge",
  "block.minecraft.ladder": "Ljestve",
  "block.minecraft.lantern": "Fenjer",
  "block.minecraft.lapis_block": "Blok lazulita",
  "block.minecraft.lapis_ore": "Ruda Lapiza",
  "block.minecraft.large_amethyst_bud": "Veliki pupoljak ametista",
  "block.minecraft.large_fern": "Velika paprat",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Kotao s lavom",
  "block.minecraft.leaf_litter": "Razbacano lišće",
  "block.minecraft.lectern": "Naslon za čitanje",
  "block.minecraft.lever": "Poluga",
  "block.minecraft.light": "Svjetlo",
  "block.minecraft.light_blue_banner": "Svijetlo plava zastava",
  "block.minecraft.light_blue_bed": "Svijetlo plavi krevet",
  "block.minecraft.light_blue_candle": "Svjetloplava svijeća",
  "block.minecraft.light_blue_candle_cake": "Torta s svijetlo plavom svijećom",
  "block.minecraft.light_blue_carpet": "Svijetlo plavi Tepih",
  "block.minecraft.light_blue_concrete": "Svijetlo plavi Beton",
  "block.minecraft.light_blue_concrete_powder": "Svijetlo plavi Betonski Prah",
  "block.minecraft.light_blue_glazed_terracotta": "Svijetlo plava Glazirana Terakota",
  "block.minecraft.light_blue_shulker_box": "Svijetlo plava kutija shulkera",
  "block.minecraft.light_blue_stained_glass": "Svijetlo Plavo staklo",
  "block.minecraft.light_blue_stained_glass_pane": "Svijetlo plava staklena ploča",
  "block.minecraft.light_blue_terracotta": "Svijetlo plava Terakota",
  "block.minecraft.light_blue_wool": "Svijetlo plava Vuna",
  "block.minecraft.light_gray_banner": "Svijetlo siva zastava",
  "block.minecraft.light_gray_bed": "Svijetlo sivi krevet",
  "block.minecraft.light_gray_candle": "Svjetlosiva svijeća",
  "block.minecraft.light_gray_candle_cake": "Torta sa svijetlo sivom svijećom",
  "block.minecraft.light_gray_carpet": "Svijetlo sivi Tepih",
  "block.minecraft.light_gray_concrete": "Svijetlo sivi Beton",
  "block.minecraft.light_gray_concrete_powder": "Svijetlo sivi Betonski Prah",
  "block.minecraft.light_gray_glazed_terracotta": "Svijetlo siva Glazirana Terakota",
  "block.minecraft.light_gray_shulker_box": "Svijetlo siva kutija shulkera",
  "block.minecraft.light_gray_stained_glass": "Svijetlo Sivo staklo",
  "block.minecraft.light_gray_stained_glass_pane": "Svijetlo siva staklena ploča",
  "block.minecraft.light_gray_terracotta": "Svijetlo siva Terakota",
  "block.minecraft.light_gray_wool": "Svijetlo siva Vuna",
  "block.minecraft.light_weighted_pressure_plate": "Lagana potisna ploča",
  "block.minecraft.lightning_rod": "Usmjerivač munje",
  "block.minecraft.lilac": "Jorgovan",
  "block.minecraft.lily_of_the_valley": "Đurđevak",
  "block.minecraft.lily_pad": "Lokvanj",
  "block.minecraft.lime_banner": "Svijetlo zelena zastava",
  "block.minecraft.lime_bed": "Svijetlo zeleni krevet",
  "block.minecraft.lime_candle": "Svjetlozelena svijeća",
  "block.minecraft.lime_candle_cake": "Torta s svijetlo zelenom svijećom",
  "block.minecraft.lime_carpet": "Svijetlo zeleni tepih",
  "block.minecraft.lime_concrete": "Svijetlo sivi Beton",
  "block.minecraft.lime_concrete_powder": "Svijetlo zeleni Betonski Prah",
  "block.minecraft.lime_glazed_terracotta": "Svijetlo zelena Glazirana Terakota",
  "block.minecraft.lime_shulker_box": "Svijetlo zelena kutija shulkera",
  "block.minecraft.lime_stained_glass": "Svijetlo Zeleno staklo",
  "block.minecraft.lime_stained_glass_pane": "Svijetlo zelena staklena ploča",
  "block.minecraft.lime_terracotta": "Svijetlo zelena Terakota",
  "block.minecraft.lime_wool": "Svijetlo zelena Vuna",
  "block.minecraft.lodestone": "Kamen vodič",
  "block.minecraft.loom": "Radni sto za zastave",
  "block.minecraft.magenta_banner": "Purpurnocrvena zastava",
  "block.minecraft.magenta_bed": "Purpurnocrveni krevet",
  "block.minecraft.magenta_candle": "Roza svijeća",
  "block.minecraft.magenta_candle_cake": "Torta s purprunocrvenom svijećom",
  "block.minecraft.magenta_carpet": "Purpurnocrveni Tepih",
  "block.minecraft.magenta_concrete": "Purpurcrveni Beton",
  "block.minecraft.magenta_concrete_powder": "Purpurnocrveni Betonski Prah",
  "block.minecraft.magenta_glazed_terracotta": "Purpurcrvena Glazirana Terakota",
  "block.minecraft.magenta_shulker_box": "Purpurnocrvena kutija shulkera",
  "block.minecraft.magenta_stained_glass": "Purpurnocrveno staklo",
  "block.minecraft.magenta_stained_glass_pane": "Purpurnocrvena staklena ploča",
  "block.minecraft.magenta_terracotta": "Purpurcrvena Terakota",
  "block.minecraft.magenta_wool": "Purpurcrvena Vuna",
  "block.minecraft.magma_block": "Blok Magme",
  "block.minecraft.mangrove_button": "Mangrovo Dugme",
  "block.minecraft.mangrove_door": "Mongrova Vrata",
  "block.minecraft.mangrove_fence": "Mangrova Ograda",
  "block.minecraft.mangrove_fence_gate": "Mangrova Ograda",
  "block.minecraft.mangrove_hanging_sign": "Mangrov Viseći Znak",
  "block.minecraft.mangrove_leaves": "Mangrovo Lišće",
  "block.minecraft.mangrove_log": "Mangrov Trup",
  "block.minecraft.mangrove_planks": "Daske Mangrova",
  "block.minecraft.mangrove_pressure_plate": "Potisna ploča od Mangrove",
  "block.minecraft.mangrove_propagule": "Mangrove Propagule",
  "block.minecraft.mangrove_roots": "Mangrovo Korijenje",
  "block.minecraft.mangrove_shelf": "Polica Mangrove",
  "block.minecraft.mangrove_sign": "Mangrov Natpis",
  "block.minecraft.mangrove_slab": "Mangrove Ploče",
  "block.minecraft.mangrove_stairs": "Mangrove Stepenice",
  "block.minecraft.mangrove_trapdoor": "Mongrova Vrata",
  "block.minecraft.mangrove_wall_hanging_sign": "Viseći mangorve zidni znak",
  "block.minecraft.mangrove_wall_sign": "Mangrov Zidni Natpis",
  "block.minecraft.mangrove_wood": "Drvo Mangrova",
  "block.minecraft.medium_amethyst_bud": "Srednji pupoljak ametista",
  "block.minecraft.melon": "Lubenica",
  "block.minecraft.melon_stem": "Stabljika lubenice",
  "block.minecraft.moss_block": "Blok mahovine",
  "block.minecraft.moss_carpet": "Tepih od mahovine",
  "block.minecraft.mossy_cobblestone": "Mahovinasta kaldrma",
  "block.minecraft.mossy_cobblestone_slab": "Obrasla Kaldrmska Stepenica",
  "block.minecraft.mossy_cobblestone_stairs": "Obrasle Kaldrmske Stepenice",
  "block.minecraft.mossy_cobblestone_wall": "Zarasli kameni Zid",
  "block.minecraft.mossy_stone_brick_slab": "Obrasla Kamena Ploča",
  "block.minecraft.mossy_stone_brick_stairs": "Obrasle Kamene Stepenice",
  "block.minecraft.mossy_stone_brick_wall": "Zid od Obraslih Kamenih Cigla",
  "block.minecraft.mossy_stone_bricks": "Obrasle Kamene Cigle",
  "block.minecraft.moving_piston": "Pokretni klip",
  "block.minecraft.mud": "Blato",
  "block.minecraft.mud_brick_slab": "Ciglena Ploča",
  "block.minecraft.mud_brick_stairs": "Stepenice od Blatnjavih Cigli",
  "block.minecraft.mud_brick_wall": "Zid od Blatnjavih Cigli",
  "block.minecraft.mud_bricks": "Blatnjave cigle",
  "block.minecraft.muddy_mangrove_roots": "Blatnjavo Korijenje Mangrova",
  "block.minecraft.mushroom_stem": "Stabljika pečurke",
  "block.minecraft.mycelium": "Micelijum",
  "block.minecraft.nether_brick_fence": "Ograda Nederskih Cigla",
  "block.minecraft.nether_brick_slab": "Ploča Nederske Cigle",
  "block.minecraft.nether_brick_stairs": "Stepenice Nederskih Cigla",
  "block.minecraft.nether_brick_wall": "Zid od Nederske Cigle",
  "block.minecraft.nether_bricks": "Neder cigle",
  "block.minecraft.nether_gold_ore": "Paklena zlatna ruda",
  "block.minecraft.nether_portal": "Pakleni Portal",
  "block.minecraft.nether_quartz_ore": "Neder kvarcna ruda",
  "block.minecraft.nether_sprouts": "Neder klice",
  "block.minecraft.nether_wart": "Nederska izraslina",
  "block.minecraft.nether_wart_block": "Neder lišaj",
  "block.minecraft.netherite_block": "Blok od nederita",
  "block.minecraft.netherrack": "Neder kamen",
  "block.minecraft.note_block": "Blok Nota",
  "block.minecraft.oak_button": "Dugme od hrasta",
  "block.minecraft.oak_door": "Vrata od hrasta",
  "block.minecraft.oak_fence": "Ograda od hrasta",
  "block.minecraft.oak_fence_gate": "Vrata za ogradu od hrasta",
  "block.minecraft.oak_hanging_sign": "Hrast Viseći znak",
  "block.minecraft.oak_leaves": "Lišće hrasta",
  "block.minecraft.oak_log": "Hrastov panj",
  "block.minecraft.oak_planks": "Daska od hrasta",
  "block.minecraft.oak_pressure_plate": "Potisna ploča od hrasta",
  "block.minecraft.oak_sapling": "Sadnica od hrasta",
  "block.minecraft.oak_shelf": "Polica Hrasta",
  "block.minecraft.oak_sign": "Hrastov Znak",
  "block.minecraft.oak_slab": "Ploča od hrasta",
  "block.minecraft.oak_stairs": "Stepenice od hrasta",
  "block.minecraft.oak_trapdoor": "Poklopac od hrasta",
  "block.minecraft.oak_wall_hanging_sign": "Hrastov viseći zidni znak",
  "block.minecraft.oak_wall_sign": "Hrastov Zidni Znak",
  "block.minecraft.oak_wood": "Drvo hrasta",
  "block.minecraft.observer": "Posmatrač",
  "block.minecraft.obsidian": "Obsidijan",
  "block.minecraft.ochre_froglight": "Okerno žablje svjetlo",
  "block.minecraft.ominous_banner": "Zlosutna zastava",
  "block.minecraft.open_eyeblossom": "Otvori cvijet očiju",
  "block.minecraft.orange_banner": "Narandžasta zastava",
  "block.minecraft.orange_bed": "Narandžasti krevet",
  "block.minecraft.orange_candle": "Narandžasta svijeća",
  "block.minecraft.orange_candle_cake": "Torta s narančastom svijećom",
  "block.minecraft.orange_carpet": "Narandžasti Tepih",
  "block.minecraft.orange_concrete": "Narandžasti Beton",
  "block.minecraft.orange_concrete_powder": "Narandžasti Betonski prah",
  "block.minecraft.orange_glazed_terracotta": "Narandžasta Glazirana Terakota",
  "block.minecraft.orange_shulker_box": "Narandžasta kutija shulkera",
  "block.minecraft.orange_stained_glass": "Narandžasto staklo",
  "block.minecraft.orange_stained_glass_pane": "Narandžasta staklena ploča",
  "block.minecraft.orange_terracotta": "Narandžasta Terakota",
  "block.minecraft.orange_tulip": "Narandžasti tulipan",
  "block.minecraft.orange_wool": "Narandžasta Vuna",
  "block.minecraft.oxeye_daisy": "Tratinčica",
  "block.minecraft.oxidized_chiseled_copper": "Oksidirani klesani bakar",
  "block.minecraft.oxidized_copper": "Oksidirani bakar",
  "block.minecraft.oxidized_copper_bars": "Oksidizirani Bakarni Šipci",
  "block.minecraft.oxidized_copper_bulb": "Oksidirana bakarna lampa",
  "block.minecraft.oxidized_copper_chain": "Oksidizirani Bakarni Lanac",
  "block.minecraft.oxidized_copper_chest": "Škrinja od oksidiranog bakra",
  "block.minecraft.oxidized_copper_door": "Oksidirana bakarna vrata",
  "block.minecraft.oxidized_copper_golem_statue": "Oksidirana Statua Bakrenog Golema",
  "block.minecraft.oxidized_copper_grate": "Oksidirana bakarna rešetka",
  "block.minecraft.oxidized_copper_lantern": "Oksidirana bakrena lampa",
  "block.minecraft.oxidized_copper_trapdoor": "Oksidirani bakarni kapak",
  "block.minecraft.oxidized_cut_copper": "Rezani oksidirani bakar",
  "block.minecraft.oxidized_cut_copper_slab": "Polublok od rezanog oksidiranog bakra",
  "block.minecraft.oxidized_cut_copper_stairs": "Stepenice od rezanog oksidiranog bakra",
  "block.minecraft.oxidized_lightning_rod": "Oksidirani gromobran",
  "block.minecraft.packed_ice": "Tvrdi led",
  "block.minecraft.packed_mud": "Pakovano Blato",
  "block.minecraft.pale_hanging_moss": "blijeda viseća mahovina",
  "block.minecraft.pale_moss_block": "Blok blijede mahovine",
  "block.minecraft.pale_moss_carpet": "Blijedi tepih od mahovine",
  "block.minecraft.pale_oak_button": "Bledo hrastovo dugme",
  "block.minecraft.pale_oak_door": "Vrata od blijedog hrasta",
  "block.minecraft.pale_oak_fence": "Ograda od blijedog hrasta",
  "block.minecraft.pale_oak_fence_gate": "Vrata ograde od blijedog hrasta",
  "block.minecraft.pale_oak_hanging_sign": "Blijedi hrastov viseći znak",
  "block.minecraft.pale_oak_leaves": "Lišće Svijetlog Hrasta",
  "block.minecraft.pale_oak_log": "blijedo hrastova cjepanica",
  "block.minecraft.pale_oak_planks": "Daska od Svijetlog Hrasta",
  "block.minecraft.pale_oak_pressure_plate": "blijedo hrastova tlačna ploča",
  "block.minecraft.pale_oak_sapling": "Mladica blijedog hrasta",
  "block.minecraft.pale_oak_shelf": "Polica od svijetlog hrasta",
  "block.minecraft.pale_oak_sign": "Znak blijedog hrasta",
  "block.minecraft.pale_oak_slab": "blijedo hrastova ploča",
  "block.minecraft.pale_oak_stairs": "Stepenice od blijedog hrasta",
  "block.minecraft.pale_oak_trapdoor": "Smeđa hrastova trap vrata",
  "block.minecraft.pale_oak_wall_hanging_sign": "Viseći Znak od Blijedog Hrasta",
  "block.minecraft.pale_oak_wall_sign": "Zidni znak od blijedog hrasta",
  "block.minecraft.pale_oak_wood": "Blijedo hrastovo drvo",
  "block.minecraft.pearlescent_froglight": "Biserno žablje svjetlo",
  "block.minecraft.peony": "Božur",
  "block.minecraft.petrified_oak_slab": "Petrifikovana ploča od hrasta",
  "block.minecraft.piglin_head": "Klipova glava",
  "block.minecraft.piglin_wall_head": "Klipska zidna glava",
  "block.minecraft.pink_banner": "Roza zastava",
  "block.minecraft.pink_bed": "Rozi krevet",
  "block.minecraft.pink_candle": "Roza svijeća",
  "block.minecraft.pink_candle_cake": "Torta s ružičastom svijećom",
  "block.minecraft.pink_carpet": "Rozi Tepih",
  "block.minecraft.pink_concrete": "Rozi Beton",
  "block.minecraft.pink_concrete_powder": "Rozi Betonski Prah",
  "block.minecraft.pink_glazed_terracotta": "Roza Glazirana Terakota",
  "block.minecraft.pink_petals": "Roza traka",
  "block.minecraft.pink_shulker_box": "Roza kutija shulkera",
  "block.minecraft.pink_stained_glass": "Rozo staklo",
  "block.minecraft.pink_stained_glass_pane": "Roza staklena ploča",
  "block.minecraft.pink_terracotta": "Roza Terakota",
  "block.minecraft.pink_tulip": "Rozi tulipan",
  "block.minecraft.pink_wool": "Roze Vuna",
  "block.minecraft.piston": "Izbacivač",
  "block.minecraft.piston_head": "Glava klipa",
  "block.minecraft.pitcher_crop": "Kruh\nštap\njabuka",
  "block.minecraft.pitcher_plant": "Pitcher Plant",
  "block.minecraft.player_head": "Lobanja od igrača",
  "block.minecraft.player_head.named": "Glava od %s",
  "block.minecraft.player_wall_head": "Zidna lobanja od igrača",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Špiljska siga",
  "block.minecraft.polished_andesite": "Polirani Andezit",
  "block.minecraft.polished_andesite_slab": "Glatka ploča od Andzita",
  "block.minecraft.polished_andesite_stairs": "Glatke stepenice od andezita",
  "block.minecraft.polished_basalt": "Polirani bazalt",
  "block.minecraft.polished_blackstone": "Polirani crni kamen",
  "block.minecraft.polished_blackstone_brick_slab": "Ploča od cigli poliranog crnog kamena",
  "block.minecraft.polished_blackstone_brick_stairs": "Stepenice od cigli poliranog crnog kamena",
  "block.minecraft.polished_blackstone_brick_wall": "Zid od cigli poliranog crnog kamena",
  "block.minecraft.polished_blackstone_bricks": "Cigle poliranog crnog kamena",
  "block.minecraft.polished_blackstone_button": "Dugme od poliranog crnog kamena",
  "block.minecraft.polished_blackstone_pressure_plate": "Nagazna ploča od poliranog crnog kamena",
  "block.minecraft.polished_blackstone_slab": "Ploča od poliranog crnog kamena",
  "block.minecraft.polished_blackstone_stairs": "Stepenice od poliranog crnog kamena",
  "block.minecraft.polished_blackstone_wall": "Zid od poliranog crnog kamena",
  "block.minecraft.polished_deepslate": "Polirani škriljevac",
  "block.minecraft.polished_deepslate_slab": "Ploča od poliranog škriljevca",
  "block.minecraft.polished_deepslate_stairs": "Stepenice od poliranog škriljevca",
  "block.minecraft.polished_deepslate_wall": "Zid od poliranog škriljevca",
  "block.minecraft.polished_diorite": "Polirani Diorit",
  "block.minecraft.polished_diorite_slab": "Glatka ploča od diorita",
  "block.minecraft.polished_diorite_stairs": "Uglancane Diorit Stepenice",
  "block.minecraft.polished_granite": "Polirani Granit",
  "block.minecraft.polished_granite_slab": "Uglancana Granitna ploča",
  "block.minecraft.polished_granite_stairs": "Uglancane stepenice od granita",
  "block.minecraft.polished_tuff": "Polirani tuf",
  "block.minecraft.polished_tuff_slab": "Polirana ploča tufa",
  "block.minecraft.polished_tuff_stairs": "Polirana stepenica tufa",
  "block.minecraft.polished_tuff_wall": "Polirani zid tufa",
  "block.minecraft.poppy": "Mak",
  "block.minecraft.potatoes": "Krompiri",
  "block.minecraft.potted_acacia_sapling": "Zasađena mladica bagrema",
  "block.minecraft.potted_allium": "Allium u saksiji",
  "block.minecraft.potted_azalea_bush": "Posađena azalea",
  "block.minecraft.potted_azure_bluet": "Hustonija u saksiji",
  "block.minecraft.potted_bamboo": "Bambus u saksiji",
  "block.minecraft.potted_birch_sapling": "Zasađena mladica breze",
  "block.minecraft.potted_blue_orchid": "Plava orhideja u saksiji",
  "block.minecraft.potted_brown_mushroom": "Braon prečurka u saksiji",
  "block.minecraft.potted_cactus": "Kaktus u saksiji",
  "block.minecraft.potted_cherry_sapling": "Zasađena mladica višnje",
  "block.minecraft.potted_closed_eyeblossom": "Zatvoreni cvijet očiju u saksiji",
  "block.minecraft.potted_cornflower": "Različak u Saksiji",
  "block.minecraft.potted_crimson_fungus": "Grimizna gljiva u saksiji",
  "block.minecraft.potted_crimson_roots": "Grimizno korijenje u saksiji",
  "block.minecraft.potted_dandelion": "Maslačak u saksiji",
  "block.minecraft.potted_dark_oak_sapling": "Zasađena Tamna Hrastova Mladica",
  "block.minecraft.potted_dead_bush": "Mrtvo grmlje u saksiji",
  "block.minecraft.potted_fern": "Paprat u saksiji",
  "block.minecraft.potted_flowering_azalea_bush": "Posađena cvatuća azalea",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Zasađena mladica džungle",
  "block.minecraft.potted_lily_of_the_valley": "Ljiljan iz doline u saksiji",
  "block.minecraft.potted_mangrove_propagule": "Mangrove Propagule",
  "block.minecraft.potted_oak_sapling": "Zasađena Hrastova Mladica",
  "block.minecraft.potted_open_eyeblossom": "Otvoreni Cvijet u Saksiji",
  "block.minecraft.potted_orange_tulip": "Narandžasti tulipan u saksiji",
  "block.minecraft.potted_oxeye_daisy": "Bijela rada u saksiji",
  "block.minecraft.potted_pale_oak_sapling": "Mladica Blijedog Hrasta u Saksiji",
  "block.minecraft.potted_pink_tulip": "Rozi tulipan u saksiji",
  "block.minecraft.potted_poppy": "Mak u saksiji",
  "block.minecraft.potted_red_mushroom": "Crvena pečurka u saksiji",
  "block.minecraft.potted_red_tulip": "Crvene tulipan u saksiji",
  "block.minecraft.potted_spruce_sapling": "Zasađena mladica smreke",
  "block.minecraft.potted_torchflower": "Potted Torchflower",
  "block.minecraft.potted_warped_fungus": "Izopačena gljiva u saksiji",
  "block.minecraft.potted_warped_roots": "Izopačeno korijenje u saksiji",
  "block.minecraft.potted_white_tulip": "Bijeli tulipan u saksiji",
  "block.minecraft.potted_wither_rose": "Zimska ruža u saksiji",
  "block.minecraft.powder_snow": "Snježni prah",
  "block.minecraft.powder_snow_cauldron": "Kotao sa snježnim prahom",
  "block.minecraft.powered_rail": "Pruga s pogonom",
  "block.minecraft.prismarine": "Prizmarin",
  "block.minecraft.prismarine_brick_slab": "Prizmarinsko  Ciglasta Ploča",
  "block.minecraft.prismarine_brick_stairs": "Prizmarinsko Ciglaste Stepenice",
  "block.minecraft.prismarine_bricks": "Cigle prizmarina",
  "block.minecraft.prismarine_slab": "Ploča od prizmarina",
  "block.minecraft.prismarine_stairs": "Stepenice od prizmarina",
  "block.minecraft.prismarine_wall": "Zid od prizmarina",
  "block.minecraft.pumpkin": "Bundeva",
  "block.minecraft.pumpkin_stem": "Stabljika od bundeve",
  "block.minecraft.purple_banner": "Ljubičasta zastava",
  "block.minecraft.purple_bed": "Ljubičasti krevet",
  "block.minecraft.purple_candle": "Ljubičasta svijeća",
  "block.minecraft.purple_candle_cake": "Torta s ljubičastom svijećom",
  "block.minecraft.purple_carpet": "Ljubičasti tepih",
  "block.minecraft.purple_concrete": "Ljubičasti Beton",
  "block.minecraft.purple_concrete_powder": "Ljubičasti Betonski Prah",
  "block.minecraft.purple_glazed_terracotta": "Ljubičasta Glazirana Terakota",
  "block.minecraft.purple_shulker_box": "Ljubičasta kutija shulkera",
  "block.minecraft.purple_stained_glass": "Ljubičasto staklo",
  "block.minecraft.purple_stained_glass_pane": "Ljubičasta staklena ploča",
  "block.minecraft.purple_terracotta": "Ljubičasta Terakota",
  "block.minecraft.purple_wool": "Ljubičasta Vuna",
  "block.minecraft.purpur_block": "Blok purpura",
  "block.minecraft.purpur_pillar": "Stub purpura",
  "block.minecraft.purpur_slab": "Ploča purpura",
  "block.minecraft.purpur_stairs": "Stepenice purpura",
  "block.minecraft.quartz_block": "Blok kvarca",
  "block.minecraft.quartz_bricks": "Kvarcne cigle",
  "block.minecraft.quartz_pillar": "Kvarcni stub",
  "block.minecraft.quartz_slab": "Kvarcna ploča",
  "block.minecraft.quartz_stairs": "Kvarcne stepenice",
  "block.minecraft.rail": "Pruga",
  "block.minecraft.raw_copper_block": "Blok sirovog bakra",
  "block.minecraft.raw_gold_block": "Blok sirovog zlata",
  "block.minecraft.raw_iron_block": "Blok sirovog metala",
  "block.minecraft.red_banner": "Crvena zastava",
  "block.minecraft.red_bed": "Crveni krevet",
  "block.minecraft.red_candle": "Crvena svijeća",
  "block.minecraft.red_candle_cake": "Torta s crvenom svijećom",
  "block.minecraft.red_carpet": "Crveni tepih",
  "block.minecraft.red_concrete": "Crveni Beton",
  "block.minecraft.red_concrete_powder": "Crveni Betonski Prah",
  "block.minecraft.red_glazed_terracotta": "Crvena Glazirana Terakota",
  "block.minecraft.red_mushroom": "Crvena pečurka",
  "block.minecraft.red_mushroom_block": "Crveni blok pečurki",
  "block.minecraft.red_nether_brick_slab": "Crvena Ploča Od Neder Cigle",
  "block.minecraft.red_nether_brick_stairs": "Stepenice od crvenih cigla iz Nedera",
  "block.minecraft.red_nether_brick_wall": "Zid od Crvene Neder Cigle",
  "block.minecraft.red_nether_bricks": "Crvena neder cigla",
  "block.minecraft.red_sand": "Crveni pijesak",
  "block.minecraft.red_sandstone": "Crveni Pješčani Kamen",
  "block.minecraft.red_sandstone_slab": "Ploča crvenog pješčanog kamena",
  "block.minecraft.red_sandstone_stairs": "Crvene Pješčane Stepenice",
  "block.minecraft.red_sandstone_wall": "Zid od crvenog pjeska",
  "block.minecraft.red_shulker_box": "Crvena Kutija Shulkera",
  "block.minecraft.red_stained_glass": "Crveno staklo",
  "block.minecraft.red_stained_glass_pane": "Crvena staklena ploča",
  "block.minecraft.red_terracotta": "Crvena Terakota",
  "block.minecraft.red_tulip": "Crveni tulipan",
  "block.minecraft.red_wool": "Crvena Vuna",
  "block.minecraft.redstone_block": "Blok redstona",
  "block.minecraft.redstone_lamp": "Redstone Lampa",
  "block.minecraft.redstone_ore": "Ruda Redstona",
  "block.minecraft.redstone_torch": "Baklja Redstona",
  "block.minecraft.redstone_wall_torch": "Zidna baklja crvenog kamena",
  "block.minecraft.redstone_wire": "Redstone žica",
  "block.minecraft.reinforced_deepslate": "Ojačani Dipslejt",
  "block.minecraft.repeater": "Redstone pojačivač",
  "block.minecraft.repeating_command_block": "Ponavljajući naredbeni blok",
  "block.minecraft.resin_block": "Blok smole",
  "block.minecraft.resin_brick_slab": "Ploča smolove cigle",
  "block.minecraft.resin_brick_stairs": "Stepenice smolove cigle",
  "block.minecraft.resin_brick_wall": "Zid od smolove cigle",
  "block.minecraft.resin_bricks": "Smolove cigle",
  "block.minecraft.resin_clump": "Gruda smole",
  "block.minecraft.respawn_anchor": "Sidro reinkarnacije",
  "block.minecraft.rooted_dirt": "Ukorijenjena zemlja",
  "block.minecraft.rose_bush": "Grm Ruže",
  "block.minecraft.sand": "Pijesak",
  "block.minecraft.sandstone": "Pješčani kamen",
  "block.minecraft.sandstone_slab": "Ploča pješčanog kamena",
  "block.minecraft.sandstone_stairs": "Pješčane Stepenice",
  "block.minecraft.sandstone_wall": "Zid od Crvenog Pješčanog Kamena",
  "block.minecraft.scaffolding": "Skele",
  "block.minecraft.sculk": "Skulk",
  "block.minecraft.sculk_catalyst": "Skulk Katalizator",
  "block.minecraft.sculk_sensor": "Sculk senzor",
  "block.minecraft.sculk_shrieker": "Skulk Šriker",
  "block.minecraft.sculk_vein": "Skulk Loza",
  "block.minecraft.sea_lantern": "Podvodni Fenjer",
  "block.minecraft.sea_pickle": "Morski krastavac",
  "block.minecraft.seagrass": "Morska trava",
  "block.minecraft.set_spawn": "Točka ponovnog stvaranja je postavljena",
  "block.minecraft.short_dry_grass": "Kratko Suho Staklo",
  "block.minecraft.short_grass": "Niska trava",
  "block.minecraft.shroomlight": "Gljivampa",
  "block.minecraft.shulker_box": "Kutija Shulkera",
  "block.minecraft.skeleton_skull": "Kosturova lobanja",
  "block.minecraft.skeleton_wall_skull": "Zidna lobanja od kostura",
  "block.minecraft.slime_block": "Ljigav blok",
  "block.minecraft.small_amethyst_bud": "Mali pupoljak ametista",
  "block.minecraft.small_dripleaf": "Mali kaplist",
  "block.minecraft.smithing_table": "Kovački sto",
  "block.minecraft.smoker": "Pušač",
  "block.minecraft.smooth_basalt": "Glatki bazalt",
  "block.minecraft.smooth_quartz": "Glatki blok kvarca",
  "block.minecraft.smooth_quartz_slab": "Glatka Kvarcna Ploča",
  "block.minecraft.smooth_quartz_stairs": "Glatke Kvarcne Stepenice",
  "block.minecraft.smooth_red_sandstone": "Glatki crveni pješčani kamen",
  "block.minecraft.smooth_red_sandstone_slab": "Glatka Crvena Pješčana Ploča",
  "block.minecraft.smooth_red_sandstone_stairs": "Glatko Crvene Pješčane Stepenice",
  "block.minecraft.smooth_sandstone": "Glatki pješčani kamen",
  "block.minecraft.smooth_sandstone_slab": "Glatka Pješčana Ploča",
  "block.minecraft.smooth_sandstone_stairs": "Glatke Pješčane Stepenice",
  "block.minecraft.smooth_stone": "Glatki kamen",
  "block.minecraft.smooth_stone_slab": "Glatki kameni prag",
  "block.minecraft.sniffer_egg": "Sniffer Egg",
  "block.minecraft.snow": "Snijeg",
  "block.minecraft.snow_block": "Sniježni blok",
  "block.minecraft.soul_campfire": "Duševna logorska vatra",
  "block.minecraft.soul_fire": "Vatra duše",
  "block.minecraft.soul_lantern": "Fenjer duše",
  "block.minecraft.soul_sand": "Živi pijesak",
  "block.minecraft.soul_soil": "Duševna zemlja",
  "block.minecraft.soul_torch": "Baklja duše",
  "block.minecraft.soul_wall_torch": "Zidna baklja duše",
  "block.minecraft.spawn.not_valid": "Tvoj krevet ili oltar za oživljavanje je uništen, ili ga nemaš",
  "block.minecraft.spawner": "Monster Spawner",
  "block.minecraft.spawner.desc1": "Interakcija sa spawn jajetom:",
  "block.minecraft.spawner.desc2": "Postavlja vrstu čudovišta",
  "block.minecraft.sponge": "Spužva",
  "block.minecraft.spore_blossom": "Cvat spore",
  "block.minecraft.spruce_button": "Dugme od smreke",
  "block.minecraft.spruce_door": "Vrata od Smreke",
  "block.minecraft.spruce_fence": "Smrekvina Ograda",
  "block.minecraft.spruce_fence_gate": "Smrekvina vrata za ogradu",
  "block.minecraft.spruce_hanging_sign": "Smreka Viseći Znak",
  "block.minecraft.spruce_leaves": "Lišće smreke",
  "block.minecraft.spruce_log": "Smrekin panj",
  "block.minecraft.spruce_planks": "Daska od smreke",
  "block.minecraft.spruce_pressure_plate": "Potisna ploča od smreke",
  "block.minecraft.spruce_sapling": "Sadnica smreke",
  "block.minecraft.spruce_shelf": "Polica od smreke",
  "block.minecraft.spruce_sign": "Smrekin Znak",
  "block.minecraft.spruce_slab": "Ploča od smreke",
  "block.minecraft.spruce_stairs": "Stepenice od smreke",
  "block.minecraft.spruce_trapdoor": "Poklopac od smreke",
  "block.minecraft.spruce_wall_hanging_sign": "Viseći znak smreke",
  "block.minecraft.spruce_wall_sign": "Smrekvin Zidni Znak",
  "block.minecraft.spruce_wood": "Drvo smreke",
  "block.minecraft.sticky_piston": "Ljepljivi Izbacivač",
  "block.minecraft.stone": "Kamen",
  "block.minecraft.stone_brick_slab": "Ploča od kamene cigle",
  "block.minecraft.stone_brick_stairs": "Stepenice od Kamenih Cigla",
  "block.minecraft.stone_brick_wall": "Zid od kamene cigle",
  "block.minecraft.stone_bricks": "Kamene Stepenice",
  "block.minecraft.stone_button": "Kameno dugme",
  "block.minecraft.stone_pressure_plate": "Kamena Potisna Ploča",
  "block.minecraft.stone_slab": "Kamena Ploča",
  "block.minecraft.stone_stairs": "Kamene Stepenice",
  "block.minecraft.stonecutter": "Kamenorezac",
  "block.minecraft.stripped_acacia_log": "Oguljen panj od bagrema",
  "block.minecraft.stripped_acacia_wood": "Oguljeno bagremovo drvo",
  "block.minecraft.stripped_bamboo_block": "Blok ogoljenog bambusa",
  "block.minecraft.stripped_birch_log": "Oguljen panj od breze",
  "block.minecraft.stripped_birch_wood": "Oguljeno brezino drvo",
  "block.minecraft.stripped_cherry_log": "Ogoljeni Cherry Log",
  "block.minecraft.stripped_cherry_wood": "Ogoljeni Cherry Log",
  "block.minecraft.stripped_crimson_hyphae": "Oguljene grimizne hife",
  "block.minecraft.stripped_crimson_stem": "Oguljeno grimizno stablo",
  "block.minecraft.stripped_dark_oak_log": "Oguljen panj od tamnog hrasta",
  "block.minecraft.stripped_dark_oak_wood": "Oguljeno tamno hrastovo drvo",
  "block.minecraft.stripped_jungle_log": "Oguljen panj od džungle",
  "block.minecraft.stripped_jungle_wood": "Oguljeno džunglino drvo",
  "block.minecraft.stripped_mangrove_log": "Oguljen Mangrov Trup",
  "block.minecraft.stripped_mangrove_wood": "Oguljeno Drvo Mangrova",
  "block.minecraft.stripped_oak_log": "Oguljen panj od hrasta",
  "block.minecraft.stripped_oak_wood": "Oguljeno hrastovo drvo",
  "block.minecraft.stripped_pale_oak_log": "Oguljen panj od blijedog hrasta",
  "block.minecraft.stripped_pale_oak_wood": "Oguljeno drvo blijedog hrasta",
  "block.minecraft.stripped_spruce_log": "Oguljen panj od smreke",
  "block.minecraft.stripped_spruce_wood": "Oguljeno smrekino drvo",
  "block.minecraft.stripped_warped_hyphae": "Oguljene grimizne hife",
  "block.minecraft.stripped_warped_stem": "Oguljeno izopačeno stablo",
  "block.minecraft.structure_block": "Strukturni blok",
  "block.minecraft.structure_void": "Strukturna praznina",
  "block.minecraft.sugar_cane": "Šećerna trska",
  "block.minecraft.sunflower": "Suncokret",
  "block.minecraft.suspicious_gravel": "Sumnjivi šljunak",
  "block.minecraft.suspicious_sand": "Sumnjivi pjesak",
  "block.minecraft.sweet_berry_bush": "Slatki žbun bobica",
  "block.minecraft.tall_dry_grass": "Visoka Suha Trava",
  "block.minecraft.tall_grass": "Visoka trava",
  "block.minecraft.tall_seagrass": "Visoka morska trava",
  "block.minecraft.target": "Meta",
  "block.minecraft.terracotta": "Terakota",
  "block.minecraft.test_block": "Test blok",
  "block.minecraft.test_instance_block": "Blok Testne Instance",
  "block.minecraft.tinted_glass": "Obojeno staklo",
  "block.minecraft.tnt": "Dinamit",
  "block.minecraft.tnt.disabled": "TNT eksplozije su onemogućene",
  "block.minecraft.torch": "Baklja",
  "block.minecraft.torchflower": "Torchflower",
  "block.minecraft.torchflower_crop": "Torchflower Crop",
  "block.minecraft.trapped_chest": "Kovčeg sa zamkom",
  "block.minecraft.trial_spawner": "Stvarač iskušenja",
  "block.minecraft.tripwire": "Nagazna žica",
  "block.minecraft.tripwire_hook": "Kuka za nagaznu žicu",
  "block.minecraft.tube_coral": "Cijevasti koral",
  "block.minecraft.tube_coral_block": "Cijevasti koralni blok",
  "block.minecraft.tube_coral_fan": "Lepeza od cijevastog korala",
  "block.minecraft.tube_coral_wall_fan": "Zidna lepeza od cijevastog korala",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Ciglena ploča tufa",
  "block.minecraft.tuff_brick_stairs": "Ciglena stepenica tufa",
  "block.minecraft.tuff_brick_wall": "Cigleni zid tufa",
  "block.minecraft.tuff_bricks": "Cigle tufa",
  "block.minecraft.tuff_slab": "Ploča tufa",
  "block.minecraft.tuff_stairs": "Stepenice tufa",
  "block.minecraft.tuff_wall": "Zid tufa",
  "block.minecraft.turtle_egg": "Jaje kornjače",
  "block.minecraft.twisting_vines": "Uvrnute lijane",
  "block.minecraft.twisting_vines_plant": "Biljka uvrnutih lijana",
  "block.minecraft.vault": "Trezor",
  "block.minecraft.verdant_froglight": "Zeleno žablje svjetlo",
  "block.minecraft.vine": "Vinova Loza",
  "block.minecraft.void_air": "Prazan vazduh",
  "block.minecraft.wall_torch": "Zidna baklja",
  "block.minecraft.warped_button": "Izopačeno dugme",
  "block.minecraft.warped_door": "Izopačena vrata",
  "block.minecraft.warped_fence": "Izopačena ograda",
  "block.minecraft.warped_fence_gate": "Vrata za izopačenu ogradu",
  "block.minecraft.warped_fungus": "Luda gljiva",
  "block.minecraft.warped_hanging_sign": "Iskrivljen viseći znak",
  "block.minecraft.warped_hyphae": "Izopačene hife",
  "block.minecraft.warped_nylium": "Izopačeni nilijum",
  "block.minecraft.warped_planks": "Izopačene daske",
  "block.minecraft.warped_pressure_plate": "Izopačena nagazna ploča",
  "block.minecraft.warped_roots": "Izopačeno korijenje",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Izopačeni znak",
  "block.minecraft.warped_slab": "Izopačena ploča",
  "block.minecraft.warped_stairs": "Izopačene stepenice",
  "block.minecraft.warped_stem": "Izopačeno stablo",
  "block.minecraft.warped_trapdoor": "Izopačena podna vrata",
  "block.minecraft.warped_wall_hanging_sign": "Iskrivljeni zidni znak",
  "block.minecraft.warped_wall_sign": "Izopačeni zidni znak",
  "block.minecraft.warped_wart_block": "Blok ludog lišaja",
  "block.minecraft.water": "Voda",
  "block.minecraft.water_cauldron": "Kotao s vodom",
  "block.minecraft.waxed_chiseled_copper": "Voštani klesani bakar",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Voštani bakreni blok",
  "block.minecraft.waxed_copper_bulb": "Voštana bakarna sijalica",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Voštana bakarna vrata",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Voštana bakarna rešetka",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Voštani bakarni kapak",
  "block.minecraft.waxed_cut_copper": "Voštani rezani bakar",
  "block.minecraft.waxed_cut_copper_slab": "Voštana ploča od rezanog bakra",
  "block.minecraft.waxed_cut_copper_stairs": "Voštane stepenice od rezanog bakra",
  "block.minecraft.waxed_exposed_chiseled_copper": "Voštani Otkriveni Klesani Bakar",
  "block.minecraft.waxed_exposed_copper": "Voštani izloženi bakar",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Voštana Otkrivena Bakarna Sijalica",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Voštana Otkrivena Bakarna Vrata",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Voštana Otkrivena Bakarna Rešetka",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Voštani Otkriveni Bakarni Kapak",
  "block.minecraft.waxed_exposed_cut_copper": "Voštani izloženi rezani bakar",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Ploča od voštanog izloženog rezanog bakra",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Stube od voštanog izloženog rezanog bakra",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Voštani Oksidirani Klesani Bakar",
  "block.minecraft.waxed_oxidized_copper": "Voštani oksidirani bakar",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Voštana Oksidirana Bakarna Sijalica",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Voštana Oksidirana Bakarna Vrata",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Voštana Oksidirana Bakarna Rešetka",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Voštani Oksidirani Bakarni Kapak",
  "block.minecraft.waxed_oxidized_cut_copper": "Voštani oksidirani rezani bakar",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Ploča od voštanog oksidiranog rezanog bakra",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Stubovi od voštanog oksidiranog rezanog bakra",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Voštani Istrošeni Klesani Bakar",
  "block.minecraft.waxed_weathered_copper": "Voštani korodirani bakar",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Voštana Istrošena Bakarna Sijalica",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Voštana Istrošena Bakarna Vrata",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Voštana Istrošena Bakarna Rešetka",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Vošteni Istrošeni Bakarni Kapak",
  "block.minecraft.waxed_weathered_cut_copper": "Rezani voštani korodirani bakar",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Polublok od rezanog voštanog korodiranog bakra",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Stube od rezanog voštanog koridiranog bakra",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Istrošeni Klesani Bakar",
  "block.minecraft.weathered_copper": "Korodirani bakar",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Istrošena Bakarna Sijalica",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Istrošena Bakarna Vrata",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Istrošena Bakarna Rešetka",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Istrošeni Bakarni Kapak",
  "block.minecraft.weathered_cut_copper": "Istrošeni rezani bakar",
  "block.minecraft.weathered_cut_copper_slab": "Istrošena ploča od rezanog bakra",
  "block.minecraft.weathered_cut_copper_stairs": "Istrošene stepenice od rezanog bakra",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Žalosne lijane",
  "block.minecraft.weeping_vines_plant": "Biljka žalosnih lijana",
  "block.minecraft.wet_sponge": "Mokra spužva",
  "block.minecraft.wheat": "Šišanje pšenice",
  "block.minecraft.white_banner": "Bijela zastava",
  "block.minecraft.white_bed": "Bijeli krevet",
  "block.minecraft.white_candle": "Bijela svijeća",
  "block.minecraft.white_candle_cake": "Torta s bijelom svijećom",
  "block.minecraft.white_carpet": "Bijeli Tepih",
  "block.minecraft.white_concrete": "Bijeli Beton",
  "block.minecraft.white_concrete_powder": "Bijeli Betonski Prah",
  "block.minecraft.white_glazed_terracotta": "Bijela Glazirana Terakota",
  "block.minecraft.white_shulker_box": "Bijela kutija shulkera",
  "block.minecraft.white_stained_glass": "Bijelo staklo",
  "block.minecraft.white_stained_glass_pane": "Bijela staklena ploča",
  "block.minecraft.white_terracotta": "Bijela Terakota",
  "block.minecraft.white_tulip": "Bijeli tulipan",
  "block.minecraft.white_wool": "Bijela Vuna",
  "block.minecraft.wildflowers": "Divlje cvijeće",
  "block.minecraft.wither_rose": "Vider ruža",
  "block.minecraft.wither_skeleton_skull": "Lobanja vider skeletona",
  "block.minecraft.wither_skeleton_wall_skull": "Zidna lobanja od vider kostura",
  "block.minecraft.yellow_banner": "Žuta zastava",
  "block.minecraft.yellow_bed": "Žuti krevet",
  "block.minecraft.yellow_candle": "Žuta svijeća",
  "block.minecraft.yellow_candle_cake": "Torta sa žutom svijećom",
  "block.minecraft.yellow_carpet": "Žuti Tepih",
  "block.minecraft.yellow_concrete": "Žuti Beton",
  "block.minecraft.yellow_concrete_powder": "Žuti Betonski Prah",
  "block.minecraft.yellow_glazed_terracotta": "Žuta Glazirana Terakota",
  "block.minecraft.yellow_shulker_box": "Žuta kutija shulkera",
  "block.minecraft.yellow_stained_glass": "Žuto staklo",
  "block.minecraft.yellow_stained_glass_pane": "Žuta staklena ploča",
  "block.minecraft.yellow_terracotta": "Žuta Terakota",
  "block.minecraft.yellow_wool": "Žuta Vuna",
  "block.minecraft.zombie_head": "Glava zombija",
  "block.minecraft.zombie_wall_head": "Zidna lobanja od zombija",
  "item.minecraft.acacia_boat": "Čamac od bagrema",
  "item.minecraft.acacia_chest_boat": "Bagremov Brod sa Kovcegom",
  "item.minecraft.allay_spawn_egg": "Jaje Aleje",
  "item.minecraft.amethyst_shard": "Krhotina ametista",
  "item.minecraft.angler_pottery_shard": "Krhotina Angler Pottery Shard",
  "item.minecraft.angler_pottery_sherd": "Angler Pottery Sherd",
  "item.minecraft.apple": "Jabuka",
  "item.minecraft.archer_pottery_shard": "Archer Pottery Shard",
  "item.minecraft.archer_pottery_sherd": "Archer Pottery Sherd",
  "item.minecraft.armadillo_scute": "Ljuska oklopnika",
  "item.minecraft.armadillo_spawn_egg": "Jaje za stvaranje armadila",
  "item.minecraft.armor_stand": "Postolje za oklop",
  "item.minecraft.arms_up_pottery_shard": "Arms Up Pottery Shard",
  "item.minecraft.arms_up_pottery_sherd": "Arms Up Pottery Sherd",
  "item.minecraft.arrow": "Strijela",
  "item.minecraft.axolotl_bucket": "Kanta s aksolotlom",
  "item.minecraft.axolotl_spawn_egg": "Jaje divlje aksolotla",
  "item.minecraft.baked_potato": "Pečeni krompir",
  "item.minecraft.bamboo_chest_raft": "Bamboo Raft sa škrinjom",
  "item.minecraft.bamboo_raft": "Bamboo Raft",
  "item.minecraft.bat_spawn_egg": "Jaje slijepog miša",
  "item.minecraft.bee_spawn_egg": "Jaje za stvaranje pčela",
  "item.minecraft.beef": "Sirova govedina",
  "item.minecraft.beetroot": "Cvekla",
  "item.minecraft.beetroot_seeds": "Sjemenke cvekle",
  "item.minecraft.beetroot_soup": "Supa od cvekle",
  "item.minecraft.birch_boat": "Brezin Čamac",
  "item.minecraft.birch_chest_boat": "Brezin Brod sa Kovcegom",
  "item.minecraft.black_bundle": "Crni Svežanj",
  "item.minecraft.black_dye": "Crna boja",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "Krhotina oštrice",
  "item.minecraft.blade_pottery_sherd": "Oštrica keramike s oštricom",
  "item.minecraft.blaze_powder": "Plamen prah",
  "item.minecraft.blaze_rod": "Plamen štap",
  "item.minecraft.blaze_spawn_egg": "Jaje vatrenog",
  "item.minecraft.blue_bundle": "Plavi Svežanj",
  "item.minecraft.blue_dye": "Plava boja",
  "item.minecraft.blue_egg": "Plavo Jaje",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Jaje Zaglibitog",
  "item.minecraft.bolt_armor_trim_smithing_template": "Kovačka šablona",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Ukras Oklopa Zavrtanj",
  "item.minecraft.bone": "Kost",
  "item.minecraft.bone_meal": "Koštano brašno",
  "item.minecraft.book": "Knjiga",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Luk",
  "item.minecraft.bowl": "Posuda",
  "item.minecraft.bread": "Hljeb",
  "item.minecraft.breeze_rod": "Vjetroviti štap",
  "item.minecraft.breeze_spawn_egg": "Jaje za stvaranje vjetrenog čudovišta",
  "item.minecraft.brewer_pottery_shard": "Brewer Pottery Shard",
  "item.minecraft.brewer_pottery_sherd": "Brewer Pottery Sherd",
  "item.minecraft.brewing_stand": "Štand za pivo",
  "item.minecraft.brick": "Cigla",
  "item.minecraft.brown_bundle": "Smeđi Svežanj",
  "item.minecraft.brown_dye": "Braon boja",
  "item.minecraft.brown_egg": "Smeđe Jaje",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "Četka",
  "item.minecraft.bucket": "Kanta",
  "item.minecraft.bundle": "Paket",
  "item.minecraft.bundle.empty": "prazan",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Pun",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Spali krhotine",
  "item.minecraft.burn_pottery_sherd": "Spali ulomak keramike",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Jaje za stvaranje kamela",
  "item.minecraft.carrot": "Šargarepa",
  "item.minecraft.carrot_on_a_stick": "Šargarepa na štapu",
  "item.minecraft.cat_spawn_egg": "Jaje za stvaranje Mačke",
  "item.minecraft.cauldron": "Kotao",
  "item.minecraft.cave_spider_spawn_egg": "Jaje pećinskog pauka",
  "item.minecraft.chainmail_boots": "Verižne čizme",
  "item.minecraft.chainmail_chestplate": "Verižni oklop",
  "item.minecraft.chainmail_helmet": "Verižni šljem",
  "item.minecraft.chainmail_leggings": "Verižne nogavice",
  "item.minecraft.charcoal": "Drveni ugalj",
  "item.minecraft.cherry_boat": "Cherry Boat",
  "item.minecraft.cherry_chest_boat": "Cherry Boat sa sandukom",
  "item.minecraft.chest_minecart": "Vagon sa kovčegom",
  "item.minecraft.chicken": "Sirova piletina",
  "item.minecraft.chicken_spawn_egg": "Jaje kokoške",
  "item.minecraft.chorus_fruit": "Horus voćka",
  "item.minecraft.clay_ball": "Glinena kugla",
  "item.minecraft.clock": "Sat",
  "item.minecraft.coal": "Ugalj",
  "item.minecraft.coast_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Obalni Ukras Oklopa",
  "item.minecraft.cocoa_beans": "Kakao zrnevlje",
  "item.minecraft.cod": "Sirov bakalar",
  "item.minecraft.cod_bucket": "Kanta sa Bakalarom",
  "item.minecraft.cod_spawn_egg": "Jaje bakalara",
  "item.minecraft.command_block_minecart": "Vagon sa Komandnim Blokom",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Biftek",
  "item.minecraft.cooked_chicken": "Pečena piletina",
  "item.minecraft.cooked_cod": "Isprženi bakalar",
  "item.minecraft.cooked_mutton": "Pečena jagnjetina",
  "item.minecraft.cooked_porkchop": "Pečena svinjetina",
  "item.minecraft.cooked_rabbit": "Pečena zečetina",
  "item.minecraft.cooked_salmon": "Kuvani losos",
  "item.minecraft.cookie": "Kolačić",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Bakrena poluga",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Jaje krave",
  "item.minecraft.creaking_spawn_egg": "Jaje Škripućeg",
  "item.minecraft.creeper_banner_pattern": "Oblik zastave",
  "item.minecraft.creeper_banner_pattern.desc": "Kriper",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Jaje kripera",
  "item.minecraft.crossbow": "Samostrel",
  "item.minecraft.crossbow.projectile": "Projektil:",
  "item.minecraft.crossbow.projectile.multiple": "Projektil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projektil: %s",
  "item.minecraft.cyan_bundle": "Tirkizni Svežanj",
  "item.minecraft.cyan_dye": "Cijan pigment",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Opasnost krhotina keramike",
  "item.minecraft.danger_pottery_sherd": "Danger Pottery Sherd",
  "item.minecraft.dark_oak_boat": "Tamni Hrastov Čamac",
  "item.minecraft.dark_oak_chest_boat": "Tamno Hrastov Brod sa Kovcegom",
  "item.minecraft.debug_stick": "Debug štapić",
  "item.minecraft.debug_stick.empty": "%s nema osobina",
  "item.minecraft.debug_stick.select": "odabrano \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" na %s",
  "item.minecraft.diamond": "Dijamant",
  "item.minecraft.diamond_axe": "Dijamantska Sjekira",
  "item.minecraft.diamond_boots": "Dijamantske čizme",
  "item.minecraft.diamond_chestplate": "Dijamantski oklop",
  "item.minecraft.diamond_helmet": "Dijamantski šljem",
  "item.minecraft.diamond_hoe": "Dijamantska Motika",
  "item.minecraft.diamond_horse_armor": "Dijamantski konjski oklop",
  "item.minecraft.diamond_leggings": "Dijamantske nogavice",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Dijamantski kramp",
  "item.minecraft.diamond_shovel": "Dijamantska lopata",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Dijamantski Mač",
  "item.minecraft.disc_fragment_5": "Fragment Diska",
  "item.minecraft.disc_fragment_5.desc": "Muzički Disk - 5",
  "item.minecraft.dolphin_spawn_egg": "Jaje delfina",
  "item.minecraft.donkey_spawn_egg": "Jaje magarca",
  "item.minecraft.dragon_breath": "Zmajev dah",
  "item.minecraft.dried_kelp": "Osučena alga",
  "item.minecraft.drowned_spawn_egg": "Jaje utopljenika",
  "item.minecraft.dune_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Ukras Oklopa Dina",
  "item.minecraft.echo_shard": "Krhotina odjeka",
  "item.minecraft.egg": "Jaje",
  "item.minecraft.elder_guardian_spawn_egg": "Jaje starog čuvara",
  "item.minecraft.elytra": "Krila",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Začarana knjiga",
  "item.minecraft.enchanted_golden_apple": "Začarana zlatna jabuka",
  "item.minecraft.end_crystal": "End kristal",
  "item.minecraft.ender_dragon_spawn_egg": "Jaje Stvaranja Krajnjeg Zmaja",
  "item.minecraft.ender_eye": "Oko endera",
  "item.minecraft.ender_pearl": "Ender biser",
  "item.minecraft.enderman_spawn_egg": "Jaje endermena",
  "item.minecraft.endermite_spawn_egg": "Jaje endermita",
  "item.minecraft.evoker_spawn_egg": "Jaje vračara",
  "item.minecraft.experience_bottle": "Boca za čini",
  "item.minecraft.explorer_pottery_shard": "Krhotina keramike Istraživač",
  "item.minecraft.explorer_pottery_sherd": "Ulomak Keramike Istraživač",
  "item.minecraft.eye_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Ukras Oklopa Oko",
  "item.minecraft.feather": "Pero",
  "item.minecraft.fermented_spider_eye": "Fermentisano paukovo oko",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Vatrena lopta",
  "item.minecraft.firework_rocket": "Vatrometska raketa",
  "item.minecraft.firework_rocket.flight": "Let traje:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Vatrometska zvijezda",
  "item.minecraft.firework_star.black": "Crni",
  "item.minecraft.firework_star.blue": "Plava",
  "item.minecraft.firework_star.brown": "Braon",
  "item.minecraft.firework_star.custom_color": "Po želji",
  "item.minecraft.firework_star.cyan": "Cijan",
  "item.minecraft.firework_star.fade_to": "Pretopi u",
  "item.minecraft.firework_star.flicker": "Svjetlucanje",
  "item.minecraft.firework_star.gray": "Siva",
  "item.minecraft.firework_star.green": "Zeleni",
  "item.minecraft.firework_star.light_blue": "Svijetlo plava",
  "item.minecraft.firework_star.light_gray": "Svijetlo siva",
  "item.minecraft.firework_star.lime": "Svijetlo zelena",
  "item.minecraft.firework_star.magenta": "Purprunocrveni",
  "item.minecraft.firework_star.orange": "Narandžasta",
  "item.minecraft.firework_star.pink": "Roze",
  "item.minecraft.firework_star.purple": "Ljubičasta",
  "item.minecraft.firework_star.red": "Crveni",
  "item.minecraft.firework_star.shape": "Nepoznati oblik",
  "item.minecraft.firework_star.shape.burst": "Prasak",
  "item.minecraft.firework_star.shape.creeper": "Oblik kripera",
  "item.minecraft.firework_star.shape.large_ball": "Velika lopta",
  "item.minecraft.firework_star.shape.small_ball": "Mala lopta",
  "item.minecraft.firework_star.shape.star": "Oblik zvijezde",
  "item.minecraft.firework_star.trail": "Trag",
  "item.minecraft.firework_star.white": "Bijela",
  "item.minecraft.firework_star.yellow": "Žuta",
  "item.minecraft.fishing_rod": "Štap za pecanje",
  "item.minecraft.flint": "Kremen",
  "item.minecraft.flint_and_steel": "Kremen i čelik",
  "item.minecraft.flow_armor_trim_smithing_template": "Kovačka šablona",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Ukras Oklopa Protok",
  "item.minecraft.flow_banner_pattern": "Banner Pattern",
  "item.minecraft.flow_banner_pattern.desc": "Protok",
  "item.minecraft.flow_banner_pattern.new": "Patern Banera Protok",
  "item.minecraft.flow_pottery_sherd": "Ulomak Keramike Protok",
  "item.minecraft.flower_banner_pattern": "Uzorak Banera",
  "item.minecraft.flower_banner_pattern.desc": "Cvijet",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Saksija",
  "item.minecraft.fox_spawn_egg": "Jaje lisice",
  "item.minecraft.friend_pottery_shard": "Prijatelj Pottery Shard",
  "item.minecraft.friend_pottery_sherd": "Prijatelj Pottery Sherd",
  "item.minecraft.frog_spawn_egg": "Jaje Stvaranja Žabe",
  "item.minecraft.furnace_minecart": "Vagon sa Peći",
  "item.minecraft.ghast_spawn_egg": "Jaje Ghasta",
  "item.minecraft.ghast_tear": "Ghasta suza",
  "item.minecraft.glass_bottle": "Staklena bočica",
  "item.minecraft.glistering_melon_slice": "Svetlucava kriška lubenice",
  "item.minecraft.globe_banner_pattern": "Uzorak Banera",
  "item.minecraft.globe_banner_pattern.desc": "Globus",
  "item.minecraft.globe_banner_pattern.new": "Patern Banera Globus",
  "item.minecraft.glow_berries": "Svjetleće bobice",
  "item.minecraft.glow_ink_sac": "Svjetleća tinta",
  "item.minecraft.glow_item_frame": "Svjetleći okvir",
  "item.minecraft.glow_squid_spawn_egg": "Jaje stvaranja svjetleće lignje",
  "item.minecraft.glowstone_dust": "Prah žarkamena",
  "item.minecraft.goat_horn": "Koziji Rog",
  "item.minecraft.goat_spawn_egg": "Jaje za stvaranje koze",
  "item.minecraft.gold_ingot": "Zlatna poluga",
  "item.minecraft.gold_nugget": "Grumen zlata",
  "item.minecraft.golden_apple": "Zlatna jabuka",
  "item.minecraft.golden_axe": "Zlatna Sjekira",
  "item.minecraft.golden_boots": "Zlatne čizme",
  "item.minecraft.golden_carrot": "Zlatna šargarepa",
  "item.minecraft.golden_chestplate": "Zlatni oklop",
  "item.minecraft.golden_helmet": "Zlatni šljem",
  "item.minecraft.golden_hoe": "Zlatna Motika",
  "item.minecraft.golden_horse_armor": "Zlatni konjski oklop",
  "item.minecraft.golden_leggings": "Zlatne nogavice",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Zlatni Kramp",
  "item.minecraft.golden_shovel": "Zlatna Lopata",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Zlatni Mač",
  "item.minecraft.gray_bundle": "Sivi Svežanj",
  "item.minecraft.gray_dye": "Sivi pigment",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Zeleni Svežanj",
  "item.minecraft.green_dye": "Zelena boja",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "Jaje čuvara",
  "item.minecraft.gunpowder": "Barut",
  "item.minecraft.guster_banner_pattern": "Patern Banera",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Srce mora",
  "item.minecraft.heart_pottery_shard": "Ulomak Keramike Srce",
  "item.minecraft.heart_pottery_sherd": "Ulomak Keramike Srce",
  "item.minecraft.heartbreak_pottery_shard": "Ulomak Keramike slomljeno srce",
  "item.minecraft.heartbreak_pottery_sherd": "Ulomak Keramike Slomljeno Srce",
  "item.minecraft.hoglin_spawn_egg": "Jaje hoglina",
  "item.minecraft.honey_bottle": "Bočica meda",
  "item.minecraft.honeycomb": "Saće",
  "item.minecraft.hopper_minecart": "Vagon sa Hoperom",
  "item.minecraft.horse_spawn_egg": "Jaje konja",
  "item.minecraft.host_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Ulomak Keramike Zavijanje",
  "item.minecraft.howl_pottery_sherd": "Ulomak Keramike Zavijanje",
  "item.minecraft.husk_spawn_egg": "Jaje pustinjskog zombija",
  "item.minecraft.ink_sac": "Vrećica sa mastilom",
  "item.minecraft.iron_axe": "Gvozdena Sjekira",
  "item.minecraft.iron_boots": "Gvozdene čizme",
  "item.minecraft.iron_chestplate": "Gvozdeni oklop",
  "item.minecraft.iron_golem_spawn_egg": "Jaje Stvaranja Gvozdenog Golema",
  "item.minecraft.iron_helmet": "Gvozdeni šljem",
  "item.minecraft.iron_hoe": "Gvozdena Motika",
  "item.minecraft.iron_horse_armor": "Gvozdeni konjski oklop",
  "item.minecraft.iron_ingot": "Gvozdena poluga",
  "item.minecraft.iron_leggings": "Gvozdene nogavice",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Grumen gvožđa",
  "item.minecraft.iron_pickaxe": "Gvozdeni Kramp",
  "item.minecraft.iron_shovel": "Gvozdena Lopata",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Gvozdeni Mač",
  "item.minecraft.item_frame": "Ram za predmete",
  "item.minecraft.jungle_boat": "Džungla Čamac",
  "item.minecraft.jungle_chest_boat": "Džunglin Brod sa Kovčegom",
  "item.minecraft.knowledge_book": "Knjiga znanja",
  "item.minecraft.lapis_lazuli": "Lapis Lazuli",
  "item.minecraft.lava_bucket": "Kanta Magme",
  "item.minecraft.lead": "Povodac",
  "item.minecraft.leather": "Koža",
  "item.minecraft.leather_boots": "Kožne čizme",
  "item.minecraft.leather_chestplate": "Kožni prsluk",
  "item.minecraft.leather_helmet": "Kožna kapa",
  "item.minecraft.leather_horse_armor": "Kožni konjski armor",
  "item.minecraft.leather_leggings": "Kožne pantalone",
  "item.minecraft.light_blue_bundle": "Svjetlo Plavi Svežanj",
  "item.minecraft.light_blue_dye": "Svijetlo plavi pigment",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Svjetlo Sivi Svežanj",
  "item.minecraft.light_gray_dye": "Svijetlo sivi pigment",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Lime Zeleni Svežanj",
  "item.minecraft.lime_dye": "Svijetlo zeleni pigment",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "Dugotrajni napitak",
  "item.minecraft.lingering_potion.effect.awkward": "Neugodni dugotrajni napitak",
  "item.minecraft.lingering_potion.effect.empty": "Dugotrajni nenapravljiv napitak",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Dugotrajni napitak otpornosti na vatru",
  "item.minecraft.lingering_potion.effect.harming": "Dugotrajni napitak povrijeđivanja",
  "item.minecraft.lingering_potion.effect.healing": "Dugotrajni napitak liječenja",
  "item.minecraft.lingering_potion.effect.infested": "Dugotrajni Napitak Zaraze",
  "item.minecraft.lingering_potion.effect.invisibility": "Dugotrajni napitak nevidljivosti",
  "item.minecraft.lingering_potion.effect.leaping": "Dugotrajni napitak skakanja",
  "item.minecraft.lingering_potion.effect.levitation": "Dugotrajni napitak levitacije",
  "item.minecraft.lingering_potion.effect.luck": "Dugotrajni napitak sreće",
  "item.minecraft.lingering_potion.effect.mundane": "Obični dugotrajni napitak",
  "item.minecraft.lingering_potion.effect.night_vision": "Dugotrajni napitak noćnog vida",
  "item.minecraft.lingering_potion.effect.oozing": "Dugotrajni Napitak Curenja",
  "item.minecraft.lingering_potion.effect.poison": "Dugotrajni napitak trovanja",
  "item.minecraft.lingering_potion.effect.regeneration": "Dugotrajni napitak regeneracije",
  "item.minecraft.lingering_potion.effect.slow_falling": "Dugotrajni napitak sporog padanja",
  "item.minecraft.lingering_potion.effect.slowness": "Dugotrajni napitak sporosti",
  "item.minecraft.lingering_potion.effect.strength": "Dugotrajni napitak snage",
  "item.minecraft.lingering_potion.effect.swiftness": "Dugotrajni napitak brzine",
  "item.minecraft.lingering_potion.effect.thick": "Gusti dugotrajni napitak",
  "item.minecraft.lingering_potion.effect.turtle_master": "Dugotrajni napitak gospodara kornjača",
  "item.minecraft.lingering_potion.effect.water": "Dugotrajna vodena boca",
  "item.minecraft.lingering_potion.effect.water_breathing": "Dugotrajni napitak disanja pod vodom",
  "item.minecraft.lingering_potion.effect.weakness": "Dugotrajni napitak slabosti",
  "item.minecraft.lingering_potion.effect.weaving": "Dugotrajni Napitak Tkanja",
  "item.minecraft.lingering_potion.effect.wind_charged": "Dugotrajni Napitak Nabijenog Vjetra",
  "item.minecraft.llama_spawn_egg": "Jaje lame",
  "item.minecraft.lodestone_compass": "Kompas vezan za kamen vodič",
  "item.minecraft.mace": "Buzdovan",
  "item.minecraft.magenta_bundle": "Magenta Svežanj",
  "item.minecraft.magenta_dye": "Purpurnocrveni pigment",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "Magma krem",
  "item.minecraft.magma_cube_spawn_egg": "Jaje kocke magme",
  "item.minecraft.mangrove_boat": "Mangrov Brod",
  "item.minecraft.mangrove_chest_boat": "Mangrov Brod sa Kovčegom",
  "item.minecraft.map": "Prazna mapa",
  "item.minecraft.melon_seeds": "Sjemena lubenice",
  "item.minecraft.melon_slice": "Kriška lubenice",
  "item.minecraft.milk_bucket": "Kanta Mlijeka",
  "item.minecraft.minecart": "Vagon",
  "item.minecraft.miner_pottery_shard": "Ulomak Keramike Rudar",
  "item.minecraft.miner_pottery_sherd": "Ulomak Keramike Rudar",
  "item.minecraft.mojang_banner_pattern": "Uzorak Banera",
  "item.minecraft.mojang_banner_pattern.desc": "Stvar",
  "item.minecraft.mojang_banner_pattern.new": "Stvar Patern Banera",
  "item.minecraft.mooshroom_spawn_egg": "Jaje mooshruma",
  "item.minecraft.mourner_pottery_shard": "Ulomak Keramike Ožalošćeni",
  "item.minecraft.mourner_pottery_sherd": "Ulomak keramike Ožaloščeni",
  "item.minecraft.mule_spawn_egg": "Jaje mazge",
  "item.minecraft.mushroom_stew": "Čorba od Gljiva",
  "item.minecraft.music_disc_11": "Muzička ploča",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Muzička ploča",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Muzička ploča",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Muzička ploča",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Muzička ploča",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Muzička ploča",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Muzička ploča",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Kreator",
  "item.minecraft.music_disc_creator_music_box": "Muzička ploča",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Kreator (Glazbena Kutija)",
  "item.minecraft.music_disc_far": "Muzička ploča",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Muzička ploča",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Muzička ploča",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Muzička ploča",
  "item.minecraft.music_disc_otherside.desc": "Lena Rejn - otherside",
  "item.minecraft.music_disc_pigstep": "Muzička ploča",
  "item.minecraft.music_disc_pigstep.desc": "Lena Rejn - Pigstep",
  "item.minecraft.music_disc_precipice": "Muzička ploča",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Provalija",
  "item.minecraft.music_disc_relic": "Muzički Disk",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Muzička ploča",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Muzička ploča",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Muzička ploča",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Muzička ploča",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Sirova jagnjetina",
  "item.minecraft.name_tag": "Oznaka Imena",
  "item.minecraft.nautilus_shell": "Nautilus školjka",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Neder cigla",
  "item.minecraft.nether_star": "Neder zvezda",
  "item.minecraft.nether_wart": "Nederska Izraslina",
  "item.minecraft.netherite_axe": "Nederitska sjekira",
  "item.minecraft.netherite_boots": "Nederitske čizme",
  "item.minecraft.netherite_chestplate": "Nederitski oklop",
  "item.minecraft.netherite_helmet": "Nederitski šljem",
  "item.minecraft.netherite_hoe": "Nederitska motika",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Nederitska poluga",
  "item.minecraft.netherite_leggings": "Nederitske nogavice",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Nederitski kramp",
  "item.minecraft.netherite_scrap": "Komad nederita",
  "item.minecraft.netherite_shovel": "Nederitska lopata",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Netheritski mač",
  "item.minecraft.netherite_upgrade_smithing_template": "Kovački šablon",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherit Nadogratnja",
  "item.minecraft.oak_boat": "Hrastov Čamac",
  "item.minecraft.oak_chest_boat": "Hrastov Brod sa Kovčegom",
  "item.minecraft.ocelot_spawn_egg": "Jaje divlje mačke",
  "item.minecraft.ominous_bottle": "Zloslutna boca",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Narančasti Svežanj",
  "item.minecraft.orange_dye": "Narandžasti pigment",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "Slika",
  "item.minecraft.pale_oak_boat": "Brod od Blijedog Hrasta",
  "item.minecraft.pale_oak_chest_boat": "Brod za Kovčegom od Blijedog Hrasta",
  "item.minecraft.panda_spawn_egg": "Jaje za stvaranje Pande",
  "item.minecraft.paper": "Papir",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Jaje papagaja",
  "item.minecraft.phantom_membrane": "Fantom membrana",
  "item.minecraft.phantom_spawn_egg": "Jaje fantoma",
  "item.minecraft.pig_spawn_egg": "Jaje svinje",
  "item.minecraft.piglin_banner_pattern": "Uzorak Banera",
  "item.minecraft.piglin_banner_pattern.desc": "Njuška",
  "item.minecraft.piglin_banner_pattern.new": "Njuška Patern Banera",
  "item.minecraft.piglin_brute_spawn_egg": "Jaje za stvaranje surovog paklenog praseta",
  "item.minecraft.piglin_spawn_egg": "Jaje paklenog praseta",
  "item.minecraft.pillager_spawn_egg": "Jaje za stvaranje razbojnika",
  "item.minecraft.pink_bundle": "Rozi Svežanj",
  "item.minecraft.pink_dye": "Ružičasti pigment",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Pitcher biljka",
  "item.minecraft.pitcher_pod": "Pitcher Pod",
  "item.minecraft.plenty_pottery_shard": "Ulomak Keramike Dosta",
  "item.minecraft.plenty_pottery_sherd": "Ulomak Keramike Dosta",
  "item.minecraft.poisonous_potato": "Otrovni krompir",
  "item.minecraft.polar_bear_spawn_egg": "Jaje polarnog medvjeda",
  "item.minecraft.popped_chorus_fruit": "Puknuto horus voće",
  "item.minecraft.porkchop": "Sirova svinjetina",
  "item.minecraft.potato": "Krompir",
  "item.minecraft.potion": "Napitak",
  "item.minecraft.potion.effect.awkward": "Čudni napitak",
  "item.minecraft.potion.effect.empty": "Nenapravljiv napitak",
  "item.minecraft.potion.effect.fire_resistance": "Napitak otpornosti na vatru",
  "item.minecraft.potion.effect.harming": "Napitak povrijeđivanja",
  "item.minecraft.potion.effect.healing": "Napitak liječenja",
  "item.minecraft.potion.effect.infested": "Napitak Infestacije",
  "item.minecraft.potion.effect.invisibility": "Napitak nevidljivosti",
  "item.minecraft.potion.effect.leaping": "Napitak skakanja",
  "item.minecraft.potion.effect.levitation": "Napitak levitacije",
  "item.minecraft.potion.effect.luck": "Napitak sreće",
  "item.minecraft.potion.effect.mundane": "Obični napitak",
  "item.minecraft.potion.effect.night_vision": "Napitak noćnog vida",
  "item.minecraft.potion.effect.oozing": "Napitak Curenja",
  "item.minecraft.potion.effect.poison": "Napitak trovanja",
  "item.minecraft.potion.effect.regeneration": "Napitak regeneracije",
  "item.minecraft.potion.effect.slow_falling": "Napitak sporog padanja",
  "item.minecraft.potion.effect.slowness": "Napitak sporosti",
  "item.minecraft.potion.effect.strength": "Napitak snage",
  "item.minecraft.potion.effect.swiftness": "Napitak brzine",
  "item.minecraft.potion.effect.thick": "Gusti napitak",
  "item.minecraft.potion.effect.turtle_master": "Napitak gospodara kornjača",
  "item.minecraft.potion.effect.water": "Boca sa vodom",
  "item.minecraft.potion.effect.water_breathing": "Napitak disanja pod vodom",
  "item.minecraft.potion.effect.weakness": "Napitak slabosti",
  "item.minecraft.potion.effect.weaving": "Napitak Tkanja",
  "item.minecraft.potion.effect.wind_charged": "Napitak Nabijanja Vjetra",
  "item.minecraft.pottery_shard_archer": "Ulomak Keramike Strijelac",
  "item.minecraft.pottery_shard_arms_up": "Ulomak Keramike Ruke Gore",
  "item.minecraft.pottery_shard_prize": "Ulomak Keramike Nagrada",
  "item.minecraft.pottery_shard_skull": "Ulomak Keramike Lobanja",
  "item.minecraft.powder_snow_bucket": "Kanta sa snježnim prahom",
  "item.minecraft.prismarine_crystals": "Kristal prizmarina",
  "item.minecraft.prismarine_shard": "Krhotina prizmarina",
  "item.minecraft.prize_pottery_shard": "Ulomak Keramike Nagrada",
  "item.minecraft.prize_pottery_sherd": "Ulomak Keramike Nagrada",
  "item.minecraft.pufferfish": "Pumpica",
  "item.minecraft.pufferfish_bucket": "Kanta sa ribom pumpicom",
  "item.minecraft.pufferfish_spawn_egg": "Jaje pumpice",
  "item.minecraft.pumpkin_pie": "Pita od bundeve",
  "item.minecraft.pumpkin_seeds": "Sjemena bundeve",
  "item.minecraft.purple_bundle": "Ljubičasti Svežanj",
  "item.minecraft.purple_dye": "Ljubičasti pigment",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "Neder kvarc",
  "item.minecraft.rabbit": "Sirova zečetina",
  "item.minecraft.rabbit_foot": "Zečja šapa",
  "item.minecraft.rabbit_hide": "Zečja koža",
  "item.minecraft.rabbit_spawn_egg": "Jaje zeca",
  "item.minecraft.rabbit_stew": "Gulaš od zeca",
  "item.minecraft.raiser_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Jaje razarača",
  "item.minecraft.raw_copper": "Sirovi bakar",
  "item.minecraft.raw_gold": "Sirovo zlato",
  "item.minecraft.raw_iron": "Sirovo gvožđe",
  "item.minecraft.recovery_compass": "Oporavni Kompas",
  "item.minecraft.red_bundle": "Crveni Svežanj",
  "item.minecraft.red_dye": "Crvena boja",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "Prah Redstona",
  "item.minecraft.resin_brick": "Cigla Smola",
  "item.minecraft.resin_clump": "Grudvica Smole",
  "item.minecraft.rib_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ukras Oklopa Rebra",
  "item.minecraft.rotten_flesh": "Trulo meso",
  "item.minecraft.saddle": "Sedlo",
  "item.minecraft.salmon": "Sirovi losos",
  "item.minecraft.salmon_bucket": "Kanta sa Lososom",
  "item.minecraft.salmon_spawn_egg": "Jaje lososa",
  "item.minecraft.scrape_pottery_sherd": "Ulomak Keramike Ogrebotina",
  "item.minecraft.scute": "Štit",
  "item.minecraft.sentry_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Ulomak Keramike Snop",
  "item.minecraft.sheaf_pottery_sherd": "Ulomak Keramike Snop",
  "item.minecraft.shears": "Makaze",
  "item.minecraft.sheep_spawn_egg": "Jaje ovce",
  "item.minecraft.shelter_pottery_shard": "Ulomak Keramike Zaklon",
  "item.minecraft.shelter_pottery_sherd": "Ulomak Keramike Zaklon",
  "item.minecraft.shield": "Štit",
  "item.minecraft.shield.black": "Crni štit",
  "item.minecraft.shield.blue": "Plavi štit",
  "item.minecraft.shield.brown": "Braon štit",
  "item.minecraft.shield.cyan": "Cijan štit",
  "item.minecraft.shield.gray": "Sivi štit",
  "item.minecraft.shield.green": "Zeleni štit",
  "item.minecraft.shield.light_blue": "Svijetlo plavi štit",
  "item.minecraft.shield.light_gray": "Svijetlo sivi štit",
  "item.minecraft.shield.lime": "Svijetlo zeleni štit",
  "item.minecraft.shield.magenta": "Purpurnocrveni štit",
  "item.minecraft.shield.orange": "Narandžasti štit",
  "item.minecraft.shield.pink": "Rozi štit",
  "item.minecraft.shield.purple": "Ljubičasti štit",
  "item.minecraft.shield.red": "Crveni štit",
  "item.minecraft.shield.white": "Bijeli štit",
  "item.minecraft.shield.yellow": "Žuti štit",
  "item.minecraft.shulker_shell": "Shulker ljuska",
  "item.minecraft.shulker_spawn_egg": "Jaje shulkera",
  "item.minecraft.sign": "Znak",
  "item.minecraft.silence_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "Jaje srebrne ribe",
  "item.minecraft.skeleton_horse_spawn_egg": "Jaje kostura konja",
  "item.minecraft.skeleton_spawn_egg": "Jaje kostura",
  "item.minecraft.skull_banner_pattern": "Uzorak Banera",
  "item.minecraft.skull_banner_pattern.desc": "Lobanja",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Ulomak Keramike Lobanja",
  "item.minecraft.skull_pottery_sherd": "Ulomak Keramike Lobanja",
  "item.minecraft.slime_ball": "Lopta od sluzi",
  "item.minecraft.slime_spawn_egg": "Jaje sluzi",
  "item.minecraft.smithing_template": "Kovački Šablon",
  "item.minecraft.smithing_template.applies_to": "Odnosi se na:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Dodaj šipku ili kristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Oklop",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Dodaj dio oklopa",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Šipke I Kristali",
  "item.minecraft.smithing_template.ingredients": "Namjernice:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Dodaj Nederitsku Šipku",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantska Oprema",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Dodaj Diamantski oklop, oružje, ili alat",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Nederitska Poluga",
  "item.minecraft.smithing_template.upgrade": "Nadograda: ",
  "item.minecraft.sniffer_spawn_egg": "Jaje Stvaranja Njuškala",
  "item.minecraft.snort_pottery_shard": "Ulomak Keramike Frktanje",
  "item.minecraft.snort_pottery_sherd": "Ulomak Keramike Frktanje",
  "item.minecraft.snout_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Ukras Oklopa Njuška",
  "item.minecraft.snow_golem_spawn_egg": "Jaje stvaranja Sniježnog golema",
  "item.minecraft.snowball": "Grudva",
  "item.minecraft.spectral_arrow": "Svijetleća Strijela",
  "item.minecraft.spider_eye": "Paukovo oko",
  "item.minecraft.spider_spawn_egg": "Jaje pauka",
  "item.minecraft.spire_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "Rasprskujući napitak",
  "item.minecraft.splash_potion.effect.awkward": "Neugodni rasprskujući napitak",
  "item.minecraft.splash_potion.effect.empty": "Rasprskujući nenapravljivi napitak",
  "item.minecraft.splash_potion.effect.fire_resistance": "Rasprskujući napitak otpornosti na vatru",
  "item.minecraft.splash_potion.effect.harming": "Rasprskujući napitak povrijeđivanja",
  "item.minecraft.splash_potion.effect.healing": "Rasprskujući napitak liječenja",
  "item.minecraft.splash_potion.effect.infested": "Rasprskujući Napitak Zaraze",
  "item.minecraft.splash_potion.effect.invisibility": "Rasprskujući napitak nevidljivosti",
  "item.minecraft.splash_potion.effect.leaping": "Rasprskujući napitak skakanja",
  "item.minecraft.splash_potion.effect.levitation": "Rasprskujući napitak levitacije",
  "item.minecraft.splash_potion.effect.luck": "Rasprskujući napitak sreće",
  "item.minecraft.splash_potion.effect.mundane": "Obični rasprskujući napitak",
  "item.minecraft.splash_potion.effect.night_vision": "Rasprskujući napitak noćnog vida",
  "item.minecraft.splash_potion.effect.oozing": "Rasprskujući Napitak Curenja",
  "item.minecraft.splash_potion.effect.poison": "Rasprskujući napitak trovanja",
  "item.minecraft.splash_potion.effect.regeneration": "Rasprskujući napitak regeneracije",
  "item.minecraft.splash_potion.effect.slow_falling": "Rasprskujući napitak sporog padanja",
  "item.minecraft.splash_potion.effect.slowness": "Rasprskujući napitak sporosti",
  "item.minecraft.splash_potion.effect.strength": "Rasprskujući napitak snage",
  "item.minecraft.splash_potion.effect.swiftness": "Rasprskujući napitak brzine",
  "item.minecraft.splash_potion.effect.thick": "Gusti rasprskujući napitak",
  "item.minecraft.splash_potion.effect.turtle_master": "Rasprskujući napitak gospodara kornjača",
  "item.minecraft.splash_potion.effect.water": "Rasprskujuća vodena boca",
  "item.minecraft.splash_potion.effect.water_breathing": "Rasprskujući napitak disanja pod vodom",
  "item.minecraft.splash_potion.effect.weakness": "Rasprskujući napitak slabosti",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Smrekin Čamac",
  "item.minecraft.spruce_chest_boat": "Smrekov Brod sa Kovcegom",
  "item.minecraft.spyglass": "Dalekozor",
  "item.minecraft.squid_spawn_egg": "Jaje lignje",
  "item.minecraft.stick": "Štap",
  "item.minecraft.stone_axe": "Kamena Sjekira",
  "item.minecraft.stone_hoe": "Kamena Motika",
  "item.minecraft.stone_pickaxe": "Kameni Kramp",
  "item.minecraft.stone_shovel": "Kamena Lopata",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Kameni Mač",
  "item.minecraft.stray_spawn_egg": "Jaje lutalice",
  "item.minecraft.strider_spawn_egg": "Jaje šetača",
  "item.minecraft.string": "Nit",
  "item.minecraft.sugar": "Šećer",
  "item.minecraft.suspicious_stew": "Sumnjiva supa",
  "item.minecraft.sweet_berries": "Slatke bobice",
  "item.minecraft.tadpole_bucket": "Kanta sa punoglavcima",
  "item.minecraft.tadpole_spawn_egg": "Jaje punoglavca",
  "item.minecraft.tide_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "Umočena strijela",
  "item.minecraft.tipped_arrow.effect.awkward": "Umočena strijela",
  "item.minecraft.tipped_arrow.effect.empty": "Nepravljena umočena strijela",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Strijela otpornosti na vatru",
  "item.minecraft.tipped_arrow.effect.harming": "Strijela povrijeđivanja",
  "item.minecraft.tipped_arrow.effect.healing": "Strijela oporavljanja",
  "item.minecraft.tipped_arrow.effect.infested": "Strijela infestacije",
  "item.minecraft.tipped_arrow.effect.invisibility": "Strijela nevidljivosti",
  "item.minecraft.tipped_arrow.effect.leaping": "Strijela skakanja",
  "item.minecraft.tipped_arrow.effect.levitation": "Strijela levitacije",
  "item.minecraft.tipped_arrow.effect.luck": "Strijela sreće",
  "item.minecraft.tipped_arrow.effect.mundane": "Umočena strijela",
  "item.minecraft.tipped_arrow.effect.night_vision": "Strelica noćnog vida",
  "item.minecraft.tipped_arrow.effect.oozing": "Strijela sluznosti",
  "item.minecraft.tipped_arrow.effect.poison": "Strijela otrova",
  "item.minecraft.tipped_arrow.effect.regeneration": "Strijela regeneracije",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Strijela sporog padanja",
  "item.minecraft.tipped_arrow.effect.slowness": "Strijela sporosti",
  "item.minecraft.tipped_arrow.effect.strength": "Strijela snage",
  "item.minecraft.tipped_arrow.effect.swiftness": "Strijela brzine",
  "item.minecraft.tipped_arrow.effect.thick": "Umočena strijela",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Strijela gospodara kornjača",
  "item.minecraft.tipped_arrow.effect.water": "Strijela rasprskivanja",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Strijela disanja pod vodom",
  "item.minecraft.tipped_arrow.effect.weakness": "Strijela slabosti",
  "item.minecraft.tipped_arrow.effect.weaving": "Strijela tkanja",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Strijela vazdušnog naboja",
  "item.minecraft.tnt_minecart": "Vagon sa Dinamitom",
  "item.minecraft.torchflower_seeds": "Sjeme cvijeća baklje",
  "item.minecraft.totem_of_undying": "Totem besmrtnosti",
  "item.minecraft.trader_llama_spawn_egg": "Jaje trgovca lame",
  "item.minecraft.trial_key": "Testni ključ",
  "item.minecraft.trident": "Trozubac",
  "item.minecraft.tropical_fish": "Tropska Riba",
  "item.minecraft.tropical_fish_bucket": "Kanta sa Tropskom Ribom",
  "item.minecraft.tropical_fish_spawn_egg": "Jaje tropske ribe",
  "item.minecraft.turtle_helmet": "Kornjačin oklop",
  "item.minecraft.turtle_scute": "Turtle Scute",
  "item.minecraft.turtle_spawn_egg": "Jaje kornjače",
  "item.minecraft.vex_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "Jaje duha",
  "item.minecraft.villager_spawn_egg": "Jaje seljaka",
  "item.minecraft.vindicator_spawn_egg": "Jaje osvetnika",
  "item.minecraft.wandering_trader_spawn_egg": "Jaje lutajućeg trgovca",
  "item.minecraft.ward_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "Jaje čuvara",
  "item.minecraft.warped_fungus_on_a_stick": "Izopačena gljiva na štapu",
  "item.minecraft.water_bucket": "Kanta Vode",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "Pšenica",
  "item.minecraft.wheat_seeds": "Sjeme pšenice",
  "item.minecraft.white_bundle": "White Bundle",
  "item.minecraft.white_dye": "Bijela boja",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Wind Charge",
  "item.minecraft.witch_spawn_egg": "Jaje veštice",
  "item.minecraft.wither_skeleton_spawn_egg": "Jaje vider kostura",
  "item.minecraft.wither_spawn_egg": "Jaje uvenućeg",
  "item.minecraft.wolf_armor": "Vučji oklop",
  "item.minecraft.wolf_spawn_egg": "Jaje vuka",
  "item.minecraft.wooden_axe": "Drvena Sjekira",
  "item.minecraft.wooden_hoe": "Drvena Motika",
  "item.minecraft.wooden_pickaxe": "Drveni Kramp",
  "item.minecraft.wooden_shovel": "Drvena Lopata",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Drveni Mač",
  "item.minecraft.writable_book": "Knjiga i pero",
  "item.minecraft.written_book": "Napisana knjiga",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "Žuta boja",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "Jaje zoglina",
  "item.minecraft.zombie_horse_spawn_egg": "Jaje zombi konja",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Jaje zombija",
  "item.minecraft.zombie_villager_spawn_egg": "Jaje seljaka zombija",
  "item.minecraft.zombified_piglin_spawn_egg": "Jaje za stvaranje paklenog zombi praseta"
}
export const bs_ba = items; 
